
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/* eslint-disable @typescript-eslint/ban-types */ /* ⬆ (Function.bind required for this implementation) */ /**
 * Generic function for debouncing some type of event handler or function. Debounce = only perform an action after specific period of time after an event stream stops.
 * @param scheduler A scheduling function that determines when the handler will run.
 * @param clearScheduler A function that will cancel the waiting handler.
 * @param handler The function to be run when the scheduler dictates.
 * @param timeout An optional timeout for the scheduling function.
 *
 * @example debounceScheduler(setTimeout, clearTimeout, (event) => console.log('event', event), 1000);
 * @example debounceScheduler(requestAnimationFrame, cancelAnimationFrame, (event) => console.log('event', event));
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $f65146e94c2f3c75$export$8255f79c28055003(scheduler, clearScheduler, handler, timeout = 500) {
    let scheduleId = 0;
    const caller = (...args)=>{
        clearScheduler(scheduleId);
        scheduleId = scheduler.apply(null, [
            handler.bind(null, ...args),
            timeout
        ]);
    };
    caller.cancel = ()=>clearScheduler(scheduleId);
    return caller;
}
const $f65146e94c2f3c75$export$61fc7d43ac8f84b0 = {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    timeout: $f65146e94c2f3c75$export$8255f79c28055003.bind(null, setTimeout, clearTimeout),
    animationFrame: $f65146e94c2f3c75$export$8255f79c28055003.bind(null, // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.requestAnimationFrame, window.cancelAnimationFrame)
};


function $ac10d40a2fa020d1$export$cacf7dd05fca3e17() {
    const memory = {};
    window.addEventListener("input", (0, $f65146e94c2f3c75$export$61fc7d43ac8f84b0).timeout((e)=>{
        const target = e.target instanceof HTMLInputElement && e.target.closest("[data-code-filter-input]");
        if (!target) return;
        const term = target?.value.toLowerCase();
        const id = target.dataset.codeFilterInput;
        const codeElt = document.querySelector(`[data-code-filter-code="${id}"]`);
        if (!id || !codeElt || !codeElt.textContent) return;
        // If we haven't save the whole contents of the block, do so.
        // eslint-disable-next-line security/detect-object-injection
        memory[id] = memory[id] || codeElt.textContent.split("\n");
        // Set text content to things that match the given term
        // eslint-disable-next-line security/detect-object-injection
        let results = memory[id].filter((line)=>line.toLowerCase().includes(term));
        // Show all if there's no value in the filter
        if (term === "") // eslint-disable-next-line security/detect-object-injection
        results = memory[id];
        else if (results.length === 0) results = [
            "No results"
        ];
        codeElt.textContent = results.join("\n");
    }, 400));
}


function $c1dcb31e94c13fa0$export$3bf7e98e931d1cdc() {
    window.addEventListener("click", (e)=>{
        const target = e.target instanceof HTMLElement && e.target.closest("#expand-figma-embed");
        if (!target) return;
        const iframe = document.getElementById("figma-embed-iframe");
        if (!iframe) return;
        iframe.requestFullscreen({
            navigationUI: "auto"
        });
    });
}


const $227e784e47219e65$export$28075517a6f9175 = window.matchMedia("(prefers-color-scheme: dark)");


/* These methods *try* to return the proper object type in the catch handler */ const $84b1501969b8c5e9$export$c2ed3351cac403d1 = {
    setItem (key, value) {
        try {
            window.localStorage.setItem(key, value);
        /* eslint no-empty: "off" */ } catch (e) {}
    },
    getItem (key) {
        try {
            return window.localStorage.getItem(key);
        } catch (e) {
            return null;
        }
    },
    removeItem (key) {
        try {
            window.localStorage.removeItem(key);
        /* eslint no-empty: "off" */ } catch (e) {}
    },
    clear () {
        try {
            window.localStorage.clear();
        /* eslint no-empty: "off" */ } catch (e) {}
    }
};
const $84b1501969b8c5e9$export$f119d83aa936d634 = {
    setItem (key, value) {
        try {
            window.sessionStorage.setItem(key, value);
        // eslint-disable-line no-empty
        } catch (e) {}
    },
    getItem (key) {
        try {
            return window.sessionStorage.getItem(key);
        } catch (e) {
            return null;
        }
    },
    removeItem (key) {
        try {
            window.sessionStorage.removeItem(key);
        // eslint-disable-line no-empty
        } catch (e) {}
    }
};


/**
 * Parses the query string into a map object.
 * Handles x-www-form-urlencoded query strings. See https://www.w3.org/TR/html401/interact/forms.html#h-17.13.4.1
 * @param queryString Optional query string to parse. If not supplied, location.search will be used.
 */ function $088734a1400ffdfa$export$66256f83798e5415(queryString) {
    let match;
    const pl = /\+/g;
    const search = /([^&=]+)=?([^&]*)/g;
    const decode = (s)=>decodeURIComponent(s.replace(pl, " "));
    if (queryString === undefined) queryString = location.search;
    queryString = queryString.substring(1);
    const urlParams = {};
    while(match = search.exec(queryString))urlParams[decode(match[1])] = decode(match[2]);
    return urlParams;
}


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
var $e9aea353ec7e87a3$exports = {};
$e9aea353ec7e87a3$exports = JSON.parse('{"animation":{"name":"animation","location":"/css/src/tokens/animation.scss","tokens":{"$input-timing-function":"cubic-bezier(0.4, 0, 0.23, 1)","$input-transition-duration":"200ms","$nav-bar-transition-duration":"86ms"}},"border":{"name":"border","location":"/css/src/tokens/border.scss","tokens":{"$border-width":"1px","$border-width-md":"0.125rem","$border-width-lg":"0.25rem","$border-radius-sm":"0.125rem","$border-radius":"0.25rem","$border-radius-lg":"0.375rem","$border-radius-rounded":"290486px"}},"breakpoints":{"name":"breakpoints","location":"/css/src/tokens/breakpoints.scss","tokens":{"$container-gap":"64px","$breakpoint-tablet":"768px","$breakpoint-desktop":"1088px","$breakpoint-widescreen":"1800px"}},"colors":{"name":"colors","location":"/css/src/tokens/colors.scss","tokens":{"$white-static":"#fff","$black-static":"#000","$text":"var(--theme-text)","$text-subtle":"var(--theme-text-subtle)","$text-invert":"var(--theme-text-invert)","$hyperlink":"var(--theme-hyperlink)","$hyperlink-hover":"var(--theme-hyperlink-hover)","$text-glow-high-contrast":"var(--theme-text-glow-high-contrast)","$box-shadow-color-light":"var(--theme-box-shadow-light)","$box-shadow-color-medium":"var(--theme-box-shadow-medium)","$box-shadow-color-heavy":"var(--theme-box-shadow-heavy)","$box-shadow-color-extra-heavy":"var(--theme-box-shadow-extra-heavy)","$body-background":"var(--theme-body-background)","$body-background-medium":"var(--theme-body-background-medium)","$body-background-accent":"var(--theme-body-background-accent)","$alternate-background":"var(--theme-alternate-background)","$alternate-background-medium":"var(--theme-alternate-background-medium)","$overlay":"var(--theme-overlay)","$overlay-invert":"var(--theme-overlay-invert)","$overlay-static":"hsla(0deg, 0%, 0%, 0.5)","$border":"var(--theme-border)","$border-accent":"var(--theme-border-accent)","$card-background":"var(--theme-card-background)","$code-header":"var(--theme-code-header)","$code-block":"var(--theme-code-block)","$inline-code":"var(--theme-inline-code)","$control-border":"var(--theme-control-border)","$control-border-bottom":"var(--theme-control-border-bottom)","$table-header":"var(--theme-table-header)","$table-row":"var(--theme-table-row)","$table-row-header":"var(--theme-table-row-header)","$table-border-dark":"var(--theme-table-border-dark)","$facepile-red":"var(--theme-facepile-red)","$facepile-teal":"var(--theme-facepile-teal)","$facepile-blue":"var(--theme-facepile-blue)","$gradient-text-purple":"var(--theme-gradient-text-purple)","$gradient-text-blue":"var(--theme-gradient-text-blue)","$gradient-vivid-start":"var(--theme-gradient-vivid-start)","$gradient-vivid-end":"var(--theme-gradient-vivid-end)","$default-hover":"var(--theme-hover-base)","$default-hover-invert":"var(--theme-hover-invert)","$border-white-high-contrast":"var(--theme-border-white-high-contrast)","$border-yellow-high-contrast":"var(--theme-border-yellow-high-contrast)","$code-highlight-background":"var(--theme-code-highlight-background)","$visited":"var(--theme-visited)","$selected-background":"var(--theme-background-selected)","$selected-background-subtle":"var(--theme-background-subtle-selected)","$selected-stroke":"var(--theme-stroke-selected)","$selected-foreground":"var(--theme-foreground-selected)","$score-low-off":"var(--theme-score-low-off)","$score-low":"var(--theme-score-low)","$score-medium-off":"var(--theme-score-medium-off)","$score-medium":"var(--theme-score-medium)","$score-high-off":"var(--theme-score-high-off)","$score-high":"var(--theme-score-high)","$primary":"var(--theme-primary-base)","$primary-background":"var(--theme-primary-background)","$primary-background-hover":"var(--theme-primary-background-hover)","$primary-background-glow-high-contrast":"var(--theme-primary-background-glow-high-contrast)","$primary-dark":"var(--theme-primary-dark)","$primary-dark-hover":"var(--theme-primary-dark-hover)","$primary-hover":"var(--theme-primary-hover)","$primary-active":"var(--theme-primary-active)","$primary-invert":"var(--theme-primary-invert)","$primary-box-shadow":"var(--theme-primary-box-shadow)","$primary-selected":"var(--theme-primary-selected)","$primary-background-selected":"var(--theme-primary-background-selected)","$primary-foreground-selected":"var(--theme-primary-foreground-selected)","$primary-foreground-selected-invert":"var(--theme-primary-foreground-selected-invert)","$primary-stroke-selected":"var(--theme-primary-stroke-selected)","$secondary":"var(--theme-secondary-base)","$secondary-background":"var(--theme-secondary-background)","$secondary-background-hover":"var(--theme-secondary-background-hover)","$secondary-background-glow-high-contrast":"var(--theme-secondary-background-glow-high-contrast)","$secondary-dark":"var(--theme-secondary-dark)","$secondary-dark-hover":"var(--theme-secondary-dark-hover)","$secondary-hover":"var(--theme-secondary-hover)","$secondary-active":"var(--theme-secondary-active)","$secondary-invert":"var(--theme-secondary-invert)","$secondary-box-shadow":"var(--theme-secondary-box-shadow)","$secondary-background-selected":"var(--theme-secondary-background-selected)","$secondary-selected":"var(--theme-secondary-selected)","$secondary-foreground-selected":"var(--theme-secondary-foreground-selected)","$secondary-foreground-selected-invert":"var(--theme-secondary-foreground-selected-invert)","$secondary-stroke-selected":"var(--theme-secondary-stroke-selected)","$tertiary":"var(--theme-tertiary-base)","$tertiary-background":"var(--theme-tertiary-background)","$tertiary-background-hover":"var(--theme-tertiary-background-hover)","$tertiary-background-glow-high-contrast":"var(--theme-tertiary-background-glow-high-contrast)","$tertiary-dark":"var(--theme-tertiary-dark)","$tertiary-dark-hover":"var(--theme-tertiary-dark-hover)","$tertiary-hover":"var(--theme-tertiary-hover)","$tertiary-active":"var(--theme-tertiary-active)","$tertiary-invert":"var(--theme-tertiary-invert)","$tertiary-box-shadow":"var(--theme-tertiary-box-shadow)","$tertiary-background-selected":"var(--theme-tertiary-background-selected)","$tertiary-selected":"var(--theme-tertiary-selected)","$tertiary-foreground-selected":"var(--theme-tertiary-foreground-selected)","$tertiary-foreground-selected-invert":"var(--theme-tertiary-foreground-selected-invert)","$tertiary-stroke-selected":"var(--theme-tertiary-stroke-selected)","$success":"var(--theme-success-base)","$success-background":"var(--theme-success-background)","$success-background-hover":"var(--theme-success-background-hover)","$success-background-glow-high-contrast":"var(--theme-success-background-glow-high-contrast)","$success-dark":"var(--theme-success-dark)","$success-dark-hover":"var(--theme-success-dark-hover)","$success-hover":"var(--theme-success-hover)","$success-active":"var(--theme-success-active)","$success-invert":"var(--theme-success-invert)","$success-box-shadow":"var(--theme-success-box-shadow)","$success-background-selected":"var(--theme-success-background-selected)","$success-selected":"var(--theme-success-selected)","$success-foreground-selected":"var(--theme-success-foreground-selected)","$success-foreground-selected-invert":"var(--theme-success-foreground-selected-invert)","$success-stroke-selected":"var(--theme-success-stroke-selected)","$info":"var(--theme-info-base)","$info-background":"var(--theme-info-background)","$info-background-hover":"var(--theme-info-background-hover)","$info-background-glow-high-contrast":"var(--theme-info-background-glow-high-contrast)","$info-dark":"var(--theme-info-dark)","$info-dark-hover":"var(--theme-info-dark-hover)","$info-hover":"var(--theme-info-hover)","$info-active":"var(--theme-info-active)","$info-invert":"var(--theme-info-invert)","$info-box-shadow":"var(--theme-info-box-shadow)","$info-background-selected":"var(--theme-info-background-selected)","$info-selected":"var(--theme-info-selected)","$info-foreground-selected":"var(--theme-info-foreground-selected)","$info-foreground-selected-invert":"var(--theme-info-foreground-selected-invert)","$info-stroke-selected":"var(--theme-info-stroke-selected)","$warning":"var(--theme-warning-base)","$warning-background":"var(--theme-warning-background)","$warning-background-hover":"var(--theme-warning-background-hover)","$warning-background-glow-high-contrast":"var(--theme-warning-background-glow-high-contrast)","$warning-dark":"var(--theme-warning-dark)","$warning-dark-hover":"var(--theme-warning-dark-hover)","$warning-hover":"var(--theme-warning-hover)","$warning-active":"var(--theme-warning-active)","$warning-invert":"var(--theme-warning-invert)","$warning-box-shadow":"var(--theme-warning-box-shadow)","$warning-background-selected":"var(--theme-warning-background-selected)","$warning-selected":"var(--theme-warning-selected)","$warning-foreground-selected":"var(--theme-warning-foreground-selected)","$warning-foreground-selected-invert":"var(--theme-warning-foreground-selected-invert)","$warning-stroke-selected":"var(--theme-warning-stroke-selected)","$danger":"var(--theme-danger-base)","$danger-background":"var(--theme-danger-background)","$danger-background-hover":"var(--theme-danger-background-hover)","$danger-background-glow-high-contrast":"var(--theme-danger-background-glow-high-contrast)","$danger-dark":"var(--theme-danger-dark)","$danger-dark-hover":"var(--theme-danger-dark-hover)","$danger-hover":"var(--theme-danger-hover)","$danger-active":"var(--theme-danger-active)","$danger-invert":"var(--theme-danger-invert)","$danger-box-shadow":"var(--theme-danger-box-shadow)","$danger-background-selected":"var(--theme-danger-background-selected)","$danger-selected":"var(--theme-danger-selected)","$danger-foreground-selected":"var(--theme-danger-foreground-selected)","$danger-foreground-selected-invert":"var(--theme-danger-foreground-selected-invert)","$danger-stroke-selected":"var(--theme-danger-stroke-selected)","$colors":{"primary":"var(--theme-primary-base),var(--theme-primary-background),var(--theme-primary-dark),var(--theme-primary-hover),var(--theme-primary-active),var(--theme-primary-invert),var(--theme-primary-box-shadow),var(--theme-primary-background-glow-high-contrast),var(--theme-primary-background-hover),var(--theme-primary-dark-hover),var(--theme-primary-selected),var(--theme-primary-background-selected),var(--theme-primary-stroke-selected),var(--theme-primary-foreground-selected),var(--theme-primary-foreground-selected-invert)","secondary":"var(--theme-secondary-base),var(--theme-secondary-background),var(--theme-secondary-dark),var(--theme-secondary-hover),var(--theme-secondary-active),var(--theme-secondary-invert),var(--theme-secondary-box-shadow),var(--theme-secondary-background-glow-high-contrast),var(--theme-secondary-background-hover),var(--theme-secondary-dark-hover),var(--theme-secondary-selected),var(--theme-secondary-background-selected),var(--theme-secondary-stroke-selected),var(--theme-secondary-foreground-selected),var(--theme-secondary-foreground-selected-invert)","tertiary":"var(--theme-tertiary-base),var(--theme-tertiary-background),var(--theme-tertiary-dark),var(--theme-tertiary-hover),var(--theme-tertiary-active),var(--theme-tertiary-invert),var(--theme-tertiary-box-shadow),var(--theme-tertiary-background-glow-high-contrast),var(--theme-tertiary-background-hover),var(--theme-tertiary-dark-hover),var(--theme-tertiary-selected),var(--theme-tertiary-background-selected),var(--theme-tertiary-stroke-selected),var(--theme-tertiary-foreground-selected),var(--theme-tertiary-foreground-selected-invert)","success":"var(--theme-success-base),var(--theme-success-background),var(--theme-success-dark),var(--theme-success-hover),var(--theme-success-active),var(--theme-success-invert),var(--theme-success-box-shadow),var(--theme-success-background-glow-high-contrast),var(--theme-success-background-hover),var(--theme-success-dark-hover),var(--theme-success-selected),var(--theme-success-background-selected),var(--theme-success-stroke-selected),var(--theme-success-foreground-selected),var(--theme-success-foreground-selected-invert)","info":"var(--theme-info-base),var(--theme-info-background),var(--theme-info-dark),var(--theme-info-hover),var(--theme-info-active),var(--theme-info-invert),var(--theme-info-box-shadow),var(--theme-info-background-glow-high-contrast),var(--theme-info-background-hover),var(--theme-info-dark-hover),var(--theme-info-selected),var(--theme-info-background-selected),var(--theme-info-stroke-selected),var(--theme-info-foreground-selected),var(--theme-info-foreground-selected-invert)","warning":"var(--theme-warning-base),var(--theme-warning-background),var(--theme-warning-dark),var(--theme-warning-hover),var(--theme-warning-active),var(--theme-warning-invert),var(--theme-warning-box-shadow),var(--theme-warning-background-glow-high-contrast),var(--theme-warning-background-hover),var(--theme-warning-dark-hover),var(--theme-warning-selected),var(--theme-warning-background-selected),var(--theme-warning-stroke-selected),var(--theme-warning-foreground-selected),var(--theme-warning-foreground-selected-invert)","danger":"var(--theme-danger-base),var(--theme-danger-background),var(--theme-danger-dark),var(--theme-danger-hover),var(--theme-danger-active),var(--theme-danger-invert),var(--theme-danger-box-shadow),var(--theme-danger-background-glow-high-contrast),var(--theme-danger-background-hover),var(--theme-danger-dark-hover),var(--theme-danger-selected),var(--theme-danger-background-selected),var(--theme-danger-stroke-selected),var(--theme-danger-foreground-selected),var(--theme-danger-foreground-selected-invert)"},"$color-index-base":"1","$color-index-background":"2","$color-index-dark":"3","$color-index-hover":"4","$color-index-active":"5","$color-index-invert":"6","$color-index-box-shadow":"7","$color-index-background-glow-high-contrast":"8","$color-index-background-hover":"9","$color-index-dark-hover":"10","$color-index-selected":"11","$color-index-background-selected":"12","$color-index-stroke-selected":"13","$color-index-foreground-selected":"14","$color-index-foreground-selected-invert":"15","$gradients":{"vivid":"var(--theme-gradient-vivid-start),var(--theme-gradient-vivid-end)","purple-blue":"var(--theme-gradient-text-purple),var(--theme-gradient-text-blue)"},"$gradient-color-start-index":"1","$gradient-color-end-index":"2"}},"container":{"name":"container","location":"/css/src/tokens/container.scss","tokens":{"$container-query-md":"480px"}},"direction":{"name":"direction","location":"/css/src/tokens/direction.scss","tokens":{"$user-text-direction":"ltr","$user-left":"left","$user-right":"right","$user-translate-x-direction":"1","$directions":{"top":"top","right":"right","bottom":"bottom","left":"left"},"$logical-directions":{"top":"block-start","right":"inline-end","bottom":"block-end","left":"inline-start"}}},"display":{"name":"display","location":"/css/src/tokens/display.scss","tokens":{"$displays":"block, flex, inline, inline-block, inline-flex, grid, none"}},"focus":{"name":"focus","location":"/css/src/tokens/focus.scss","tokens":{"$focus-width":"0.125rem","$focus-style":"dashed","$focus-outline-offset":"0.25rem","$focus-visible-use-polyfill":false}},"font-stack":{"name":"font-stack","location":"/css/src/tokens/font-stack.scss","tokens":{"$monospace-font-stack":"SFMono-Regular, Consolas, Liberation Mono, Menlo, Courier, monospace","$normal-font-stack":"-apple-system, BlinkMacSystemFont, Segoe UI Variable Text, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji","$quote-font-stack":"Arial, Helvetica Neue, Helvetica, sans-serif"}},"layout":{"name":"layout","location":"/css/src/tokens/layout.scss","tokens":{"$column-gap":"0.75rem","$large-column-gap":"1.5rem","$reading-max-width":"50rem","$layout-gap":"24px","$layout-widescreen-width":"1752px","$layout-widescreen-gap":"max(24px, 50% - 1752px / 2)","$layout-gap-custom-property-name":"--layout-gap","$layout-gap-scalable-custom-property-name":"--layout-gap-scalable","$layout-flyout-width-name":"--layout-flyout-width","$layout-flyout-width-desktop-custom-property-name":"--layout-flyout-width-desktop","$layout-flyout-width-widescreen-custom-property-name":"--layout-flyout-width-widescreen"}},"palette":{"name":"palette","location":"/css/src/tokens/palette.scss","tokens":{"$palette-grey-10-deprecated":"#fafafa","$palette-grey-20-deprecated":"#f2f2f2","$palette-grey-30-deprecated":"#e6e6e6","$palette-grey-40-deprecated":"#d2d2d2","$palette-grey-50-deprecated":"#bcbcbc","$palette-grey-60-deprecated":"#a2a2a2","$palette-grey-70-deprecated":"#8e8e8e","$palette-grey-80-deprecated":"#757575","$palette-grey-90-deprecated":"#505050","$palette-grey-100-deprecated":"#404040","$palette-grey-110-deprecated":"#2f2f2f","$palette-grey-120-deprecated":"#171717","$palette-grey-130-deprecated":"#161616","$palette-grey-10":"#f5f5f5","$palette-grey-20":"#f0f0f0","$palette-grey-30":"#ebebeb","$palette-grey-40":"#e6e6e6","$palette-grey-50":"#e0e0e0","$palette-grey-60":"#d6d6d6","$palette-grey-70":"#d1d1d1","$palette-grey-80":"#c7c7c7","$palette-grey-90":"#bdbdbd","$palette-grey-100":"#b3b3b3","$palette-grey-110":"#adadad","$palette-grey-120":"#999","$palette-grey-130":"#757575","$palette-grey-140":"#707070","$palette-grey-150":"#6b6b6b","$palette-grey-160":"#666","$palette-grey-170":"#616161","$palette-grey-180":"#575757","$palette-grey-190":"#525252","$palette-grey-200":"#4d4d4d","$palette-grey-210":"#424242","$palette-grey-220":"#3d3d3d","$palette-grey-230":"#383838","$palette-grey-240":"#333","$palette-grey-250":"#292929","$palette-grey-260":"#242424","$palette-grey-270":"#1a1a1a","$palette-grey-280":"#1f1f1f","$palette-grey-290":"#141414","$palette-grey-300":"#0a0a0a","$palette-black":"#000","$palette-black-opacity-90":"hsla(0deg, 0%, 0%, 0.9)","$palette-black-opacity-80":"hsla(0deg, 0%, 0%, 0.8)","$palette-black-opacity-70":"hsla(0deg, 0%, 0%, 0.7)","$palette-black-opacity-60":"hsla(0deg, 0%, 0%, 0.6)","$palette-black-opacity-50":"hsla(0deg, 0%, 0%, 0.5)","$palette-black-opacity-40":"hsla(0deg, 0%, 0%, 0.4)","$palette-black-opacity-30":"hsla(0deg, 0%, 0%, 0.3)","$palette-black-opacity-20":"hsla(0deg, 0%, 0%, 0.2)","$palette-black-opacity-10":"hsla(0deg, 0%, 0%, 0.1)","$palette-black-opacity-0":"hsla(0deg, 0%, 0%, 0)","$palette-white":"#fff","$palette-white-opacity-0":"hsla(0deg, 0%, 100%, 0)","$palette-white-opacity-10":"hsla(0deg, 0%, 100%, 0.1)","$palette-white-opacity-20":"hsla(0deg, 0%, 100%, 0.2)","$palette-white-opacity-30":"hsla(0deg, 0%, 100%, 0.3)","$palette-white-opacity-40":"hsla(0deg, 0%, 100%, 0.4)","$palette-white-opacity-50":"hsla(0deg, 0%, 100%, 0.5)","$palette-white-opacity-60":"hsla(0deg, 0%, 100%, 0.6)","$palette-white-opacity-70":"hsla(0deg, 0%, 100%, 0.7)","$palette-white-opacity-80":"hsla(0deg, 0%, 100%, 0.8)","$palette-white-opacity-90":"hsla(0deg, 0%, 100%, 0.9)","$palette-black-opacity-108":"hsla(0deg, 0%, 0%, 0.11)","$palette-black-opacity-132":"hsla(0deg, 0%, 0%, 0.13)","$palette-black-opacity-22":"hsla(0deg, 0%, 0%, 0.22)","$palette-black-opacity-18":"hsla(0deg, 0%, 0%, 0.18)","$palette-white-opacity-108":"hsla(0deg, 0%, 100%, 0.11)","$palette-white-opacity-132":"hsla(0deg, 0%, 100%, 0.13)","$palette-white-opacity-22":"hsla(0deg, 0%, 100%, 0.22)","$palette-white-opacity-18":"hsla(0deg, 0%, 100%, 0.18)","$palette-blue-10-deprecated":"#d7eaf8","$palette-blue-20-deprecated":"#9ccbee","$palette-blue-30-deprecated":"#75b6e7","$palette-blue-40-deprecated":"#278cda","$palette-blue-50-deprecated":"#0078d4","$palette-blue-60-deprecated":"#0065b3","$palette-blue-70-deprecated":"#00579a","$palette-blue-80-deprecated":"#004173","$palette-blue-90-deprecated":"#002b4d","$palette-blue-100-deprecated":"#000a13","$palette-blue-10":"#ebf3fc","$palette-blue-20":"#cfe4fa","$palette-blue-30":"#a9d3f2","$palette-blue-40":"#b4d6fa","$palette-blue-50":"#9abfdc","$palette-blue-60":"#77b7f7","$palette-blue-70":"#62abf5","$palette-blue-80":"#479ef5","$palette-blue-90":"#2886de","$palette-blue-100":"#0078d4","$palette-blue-110":"#0f6cbd","$palette-blue-120":"#115ea3","$palette-blue-130":"#0f548c","$palette-blue-140":"#004e8c","$palette-blue-150":"#0e4775","$palette-blue-160":"#004377","$palette-blue-170":"#0c3b5e","$palette-blue-180":"#0a2e4a","$palette-blue-190":"#002c4e","$palette-blue-200":"#082338","$palette-blue-a":"#9ccbee","$palette-blue-opacity-30":"hsla(206deg, 100%, 35%, 0.3)","$palette-blue-opacity-70":"hsla(206deg, 100%, 35%, 0.7)","$palette-blue-black":"#091f2c","$palette-navy-10":"#dfe5ee","$palette-navy-20":"#c1cbdc","$palette-navy-30":"#a4b2c9","$palette-navy-40":"#899ab5","$palette-navy-50":"#70819f","$palette-navy-60":"#4a5d7e","$palette-navy-70":"#243a5e","$palette-navy-80":"#14294c","$palette-navy-90":"#061329","$palette-navy-100":"#000910","$palette-navy-opacity-30":"hsla(262deg, 46%, 17%, 0.3)","$palette-navy-opacity-70":"hsla(262deg, 46%, 17%, 0.7)","$palette-turqoise-10-deprecated":"#e9fbff","$palette-turqoise-20-deprecated":"#bdf5ff","$palette-turqoise-30-deprecated":"#7becff","$palette-turqoise-40-deprecated":"#50e6ff","$palette-turqoise-50-deprecated":"#41b9cf","$palette-turqoise-60-deprecated":"#328e9f","$palette-turqoise-70-deprecated":"#28727f","$palette-turqoise-80-deprecated":"#19474f","$palette-turqoise-90-deprecated":"#0f2a2f","$palette-turqoise-100-deprecated":"#050e0f","$palette-turqoise-10":"#1aebff","$palette-turqoise-20":"#00666d","$palette-turqoise-opacity-30-deprecated":"hsla(189deg, 52%, 12%, 0.3)","$palette-turqoise-opacity-70-deprecated":"hsla(189deg, 52%, 12%, 0.7)","$palette-green-10-deprecated":"#dff6dd","$palette-green-20-deprecated":"#acd7aa","$palette-green-30-deprecated":"#7cbb7b","$palette-green-40-deprecated":"#489d48","$palette-green-50-deprecated":"#2a8b2a","$palette-green-60-deprecated":"#107c10","$palette-green-70-deprecated":"#0b6413","$palette-green-80-deprecated":"#054b16","$palette-green-90-deprecated":"#05350c","$palette-green-100-deprecated":"#061a00","$palette-green-10":"#f1faf1","$palette-green-20":"#bdd99b","$palette-green-30":"#a8f0cd","$palette-green-40":"#a7e3a5","$palette-green-50":"#9fd89f","$palette-green-60":"#9ad29a","$palette-green-70":"#5ae0a0","$palette-green-80":"#5ec75a","$palette-green-90":"#54b054","$palette-green-100":"#3db838","$palette-green-110":"#00cc6a","$palette-green-120":"#4da64d","$palette-green-130":"#13a10e","$palette-green-140":"#359b35","$palette-green-150":"#498205","$palette-green-160":"#11910d","$palette-green-170":"#2a8b2a","$palette-green-180":"#107c10","$palette-green-190":"#00723b","$palette-green-200":"#0e700e","$palette-green-210":"#0b5a08","$palette-green-220":"#294903","$palette-green-230":"#094509","$palette-green-240":"#063b06","$palette-green-250":"#052505","$palette-green-opacity-30":"hsla(120deg, 37%, 45%, 0.3)","$palette-green-opacity-70":"hsla(120deg, 37%, 45%, 0.7)","$palette-purple-10":"#efd9fd","$palette-purple-20":"#e0b7fe","$palette-purple-30":"#d59dff","$palette-purple-40":"#ac7ee1","$palette-purple-50":"#9970d3","$palette-purple-60":"#8661c5","$palette-purple-70":"#624991","$palette-purple-80":"#3b2e58","$palette-purple-90":"#201843","$palette-purple-100":"#03002c","$palette-purple-a":"#cd9bcf","$palette-purple-b":"#702573","$palette-purple-c":"#b84dc6","$palette-purple-opacity-30":"hsla(251deg, 47%, 18%, 0.3)","$palette-purple-opacity-70":"hsla(251deg, 47%, 18%, 0.7)","$palette-yellow-10-deprecated":"#fff4ce","$palette-yellow-20-deprecated":"#ffe79f","$palette-yellow-30-deprecated":"#ffdf84","$palette-yellow-40-deprecated":"#ffcb3f","$palette-yellow-50-deprecated":"#ffb900","$palette-yellow-60-deprecated":"#d19501","$palette-yellow-70-deprecated":"#966802","$palette-yellow-80-deprecated":"#6a4b16","$palette-yellow-90-deprecated":"#4f340e","$palette-yellow-100-deprecated":"#2d1703","$palette-yellow-10":"#fffef5","$palette-yellow-20":"#ecdfa5","$palette-yellow-30":"#e0cea2","$palette-yellow-40":"#ddc3b0","$palette-yellow-50":"#fef7b2","$palette-yellow-60":"#ffe79f","$palette-yellow-70":"#feee66","$palette-yellow-80":"#fdea3d","$palette-yellow-90":"#dac157","$palette-yellow-100":"#fde300","$palette-yellow-110":"#ffcb3f","$palette-yellow-120":"#c1a256","$palette-yellow-130":"#c19c00","$palette-yellow-140":"#bb8f6f","$palette-yellow-150":"#986f0b","$palette-yellow-160":"#817400","$palette-yellow-170":"#6c5700","$palette-yellow-180":"#4c4400","$palette-yellow-190":"#553e06","$palette-yellow-200":"#50301a","$palette-yellow-opacity-30":"hsla(44deg, 100%, 50%, 0.3)","$palette-yellow-opacity-70":"hsla(44deg, 100%, 50%, 0.7)","$palette-yellow-sand":"#e8e6df","$palette-orange-10":"#fff9f5","$palette-orange-20":"#fdf6f3","$palette-orange-30":"#ffddb3","$palette-orange-40":"#fdcfb4","$palette-orange-50":"#efc4ad","$palette-orange-60":"#f4bfab","$palette-orange-70":"#faa06b","$palette-orange-80":"#df8e64","$palette-orange-90":"#ff8c00","$palette-orange-100":"#f98845","$palette-orange-110":"#e9835e","$palette-orange-120":"#f7630c","$palette-orange-130":"#ca5010","$palette-orange-140":"#bc4b09","$palette-orange-150":"#da3b01","$palette-orange-160":"#c43501","$palette-orange-170":"#8f4e00","$palette-orange-180":"#8a3707","$palette-orange-190":"#712d09","$palette-orange-200":"#7a2101","$palette-orange-210":"#4a1e04","$palette-orange-220":"#411200","$palette-orange-opacity-30":"hsla(24deg, 100%, 50%, 0.3)","$palette-orange-opacity-70":"hsla(24deg, 100%, 50%, 0.7)","$palette-red-10-deprecated":"#fde7e9","$palette-red-20-deprecated":"#e5a7a8","$palette-red-30-deprecated":"#d4797a","$palette-red-40-deprecated":"#c54f4f","$palette-red-50-deprecated":"#b62626","$palette-red-60-deprecated":"#a80000","$palette-red-70-deprecated":"#870000","$palette-red-80-deprecated":"#630001","$palette-red-90-deprecated":"#470001","$palette-red-100-deprecated":"#290001","$palette-red-10":"#fdf3f4","$palette-red-20":"#fdf6f6","$palette-red-30":"#f1bbbc","$palette-red-40":"#eeacb2","$palette-red-50":"#d69ca5","$palette-red-60":"#e37d80","$palette-red-70":"#dc626d","$palette-red-80":"#dc5e62","$palette-red-90":"#ac4f5e","$palette-red-100":"#d13438","$palette-red-110":"#bc2f32","$palette-red-120":"#b62626","$palette-red-130":"#c50f1f","$palette-red-140":"#b10e1c","$palette-red-150":"#751d1f","$palette-red-160":"#750b1c","$palette-red-170":"#6e0811","$palette-red-180":"#590815","$palette-red-190":"#420610","$palette-red-200":"#3b0509","$palette-red-210":"#3f1011","$palette-red-opacity-30":"hsla(0deg, 100%, 33%, 0.3)","$palette-red-opacity-70":"hsla(0deg, 100%, 33%, 0.7)","$palette-yellow-high-contrast":"#ff0","$palette-yellow-high-contrast-hover":"#ff3","$palette-yellow-high-contrast-selected":"#fd0","$palette-visited-high-contrast":"#3cff00"}},"position":{"name":"position","location":"/css/src/tokens/position.scss","tokens":{"$positions":"fixed, absolute, relative, sticky"}},"schemes":{"name":"schemes","location":"/css/src/tokens/schemes.scss","tokens":{"$color-schemes":{"light":"light","dark":"dark","high-contrast":"dark"}}},"shadow":{"name":"shadow","location":"/css/src/tokens/shadow.scss","tokens":{"$box-shadow-light":"0 1.6px 3.6px 0 var(--theme-box-shadow-medium), 0 0.3px 0.9px 0 var(--theme-box-shadow-light)","$box-shadow-medium":"0 3.2px 7.2px 0 var(--theme-box-shadow-medium), 0 0.6px 1.8px 0 var(--theme-box-shadow-light)","$box-shadow-heavy":"0 6.4px 14.4px 0 var(--theme-box-shadow-medium), 0 1.2px 3.6px 0 var(--theme-box-shadow-light)","$box-shadow-extra-heavy":"0 25.6px 57.6px 0 var(--theme-box-shadow-extra-heavy), 0 4.8px 14.4px 0 var(--theme-box-shadow-heavy)"}},"spacing":{"name":"spacing","location":"/css/src/tokens/spacing.scss","tokens":{"$layout-0":"0","$layout-1":"0.5rem","$layout-2":"1rem","$layout-3":"1.5rem","$layout-4":"2rem","$layout-5":"3rem","$layout-6":"4rem","$layout-7":"6rem","$layout-8":"8rem","$spacer-0":"0","$spacer-1":"0.125rem","$spacer-2":"0.25rem","$spacer-3":"0.5rem","$spacer-4":"0.75rem","$spacer-5":"1rem","$spacer-6":"1.25rem","$spacer-7":"1.5rem","$spacer-8":"2rem","$spacer-9":"2.5rem","$spacer-10":"3rem"}},"themes":{"name":"themes","location":"/css/src/tokens/themes.scss","tokens":{"$themes":{"light":{"text":"#161616","text-subtle":"#505050","text-invert":"#fff","text-glow-high-contrast":"#171717","box-shadow-light":"hsla0deg,0%,0%,0.11)","box-shadow-medium":"hsla(0deg,0%,0%,0.13)","box-shadow-heavy":"hsla(0deg,0%,0%,0.18)","box-shadow-extra-heavy":"hsla(0deg,0%,0%,0.22)","overlay":"hsla(0deg,0%,0%,0.7)","overlay-invert":"#fff","body-background":"#fff","body-background-accent":"#e8e6df","body-background-medium":"#f2f2f2","alternate-background":"#171717","alternate-background-medium":"#2f2f2f","card-background":"#fff","border":"#e6e6e6","border-accent":"#e8e6df","border-white-high-contrast":"hsla(0deg,0%,100%,0)","border-yellow-high-contrast":"hsla(0deg,0%,0%,0)","table-header":"#e6e6e6","table-row":"#f0f0f0","table-row-header":"#f5f5f5","table-border-dark":"#d1d1d1","hover-base":"#c7c7c7","hover-invert":"#f5f5f5","background-selected":"#ebebeb","background-subtle-selected":"#ebebeb","foreground-selected":"#242424","stroke-selected":"#bdbdbd","code-header":"#e6e6e6","code-block":"#f0f0f0","control-border":"#d1d1d1","control-border-bottom":"#616161","inline-code":"#e6e6e6","code-highlight-background":"#fef7b2","visited":"#624991","score-low-off":"hsla(0deg,100%,33%,0.3)","score-low":"#b62626","score-medium-off":"hsla(44deg,100%,50%,0.3)","score-medium":"#ffb900","score-high-off":"hsla(120deg,37%,45%,0.3)","score-high":"#2a8b2a","hyperlink":"#0065b3","primary-base":"#0f6cbd","primary-background":"#ebf3fc","primary-background-hover":"#cfe4fa","primary-background-glow-high-contrast":"#ebf3fc","primary-background-selected":"#cfe4fa","primary-foreground-selected":"#0f548c","primary-foreground-selected-invert":"#fff","primary-selected":"#0f548c","primary-stroke-selected":"#0f548c","primary-dark":"#115ea3","primary-dark-hover":"#115ea3","primary-hover":"#115ea3","primary-active":"#0c3b5e","primary-box-shadow":"hsla(206deg,100%,35%,0.3)","primary-invert":"#fff","secondary-base":"#ebebeb","secondary-background":"#f5f5f5","secondary-background-hover":"#ebebeb","secondary-background-glow-high-contrast":"#f0f0f0","secondary-background-selected":"#ebebeb","secondary-foreground-selected":"#242424","secondary-foreground-selected-invert":"#ebebeb","secondary-selected":"#242424","secondary-stroke-selected":"#bdbdbd","secondary-dark":"#424242","secondary-dark-hover":"#d6d6d6","secondary-hover":"#c7c7c7","secondary-active":"#b3b3b3","secondary-box-shadow":"hsla(0deg,0%,0%,0.3)","secondary-invert":"#000","tertiary-base":"#243a5e","tertiary-background":"#061329","tertiary-background-hover":"#4a5d7e","tertiary-background-selected":"#70819f","tertiary-foreground-selected":"#061329","tertiary-foreground-selected-invert":"#fff","tertiary-selected":"#061329","tertiary-stroke-selected":"#061329","tertiary-background-glow-high-contrast":"#061329","tertiary-dark":"#a4b2c9","tertiary-dark-hover":"#70819f","tertiary-hover":"#14294c","tertiary-active":"#70819f","tertiary-box-shadow":"hsla(262deg,46%,17%,0.3)","tertiary-invert":"#fff","success-base":"#107c10","success-background":"#f1faf1","success-background-hover":"#9fd89f","success-background-selected":"#a7e3a5","success-foreground-selected":"#094509","success-foreground-selected-invert":"#fff","success-selected":"#094509","success-stroke-selected":"#094509","success-background-glow-high-contrast":"#f1faf1","success-dark":"#0e700e","success-dark-hover":"#13a10e","success-hover":"#0b5a08","success-active":"#9fd89f","success-box-shadow":"hsla(120deg,37%,45%,0.3)","success-invert":"#fff","info-base":"#8661c5","info-background":"#efd9fd","info-background-hover":"#d59dff","info-background-selected":"#e0b7fe","info-foreground-selected":"#3b2e58","info-foreground-selected-invert":"#fff","info-selected":"#624991","info-stroke-selected":"#3b2e58","info-background-glow-high-contrast":"#efd9fd","info-dark":"#3b2e58","info-dark-hover":"#8661c5","info-hover":"#8661c5","info-active":"#624991","info-box-shadow":"hsla(251deg,47%,18%,0.3)","info-invert":"#fff","warning-base":"#f7630c","warning-background":"#fff9f5","warning-background-hover":"#fdcfb4","warning-background-selected":"#ffddb3","warning-foreground-selected":"#8a3707","warning-foreground-selected-invert":"#fff","warning-selected":"#bc4b09","warning-stroke-selected":"#8a3707","warning-background-glow-high-contrast":"#fff9f5","warning-dark":"#8a3707","warning-dark-hover":"#da3b01","warning-hover":"#ca5010","warning-active":"#c43501","warning-box-shadow":"hsla(24deg,100%,50%,0.3)","warning-invert":"#000","danger-base":"#bc2f32","danger-background":"#fdf3f4","danger-background-hover":"#eeacb2","danger-background-selected":"#f1bbbc","danger-foreground-selected":"#751d1f","danger-foreground-selected-invert":"#fff","danger-selected":"#751d1f","danger-stroke-selected":"#751d1f","danger-background-glow-high-contrast":"#fdf3f4","danger-dark":"#b10e1c","danger-dark-hover":"#751d1f","danger-hover":"#b10e1c","danger-active":"#bc2f32","danger-box-shadow":"hsla(0deg,100%,33%,0.3)","danger-invert":"#fff","facepile-red":"#b10e1c","facepile-teal":"#00666d","facepile-blue":"#0078d4","gradient-text-purple":"#702573","gradient-text-blue":"#0f548c","gradient-vivid-start":"#b84dc6","gradient-vivid-end":"#0078d4"},"dark":{"text":"#e6e6e6","text-subtle":"#d2d2d2","text-invert":"#2f2f2f","text-glow-high-contrast":"#e6e6e6","box-shadow-light":"hsla0deg,0%,0%,0.11)","box-shadow-medium":"hsla(0deg,0%,0%,0.13)","box-shadow-heavy":"hsla(0deg,0%,0%,0.18)","box-shadow-extra-heavy":"hsla(0deg,0%,0%,0.22)","overlay":"hsla(0deg,0%,0%,0.7)","overlay-invert":"#fff","body-background":"#1a1a1a","body-background-accent":"#091f2c","body-background-medium":"#292929","alternate-background":"#f2f2f2","alternate-background-medium":"#fafafa","border":"#404040","border-accent":"#505050","border-white-high-contrast":"hsla(0deg,0%,100%,0)","border-yellow-high-contrast":"hsla(0deg,0%,0%,0)","card-background":"#091f2c","table-header":"#404040","table-row":"#2f2f2f","table-row-header":"#2f2f2f","table-border-dark":"#505050","hover-base":"#d2d2d2","hover-invert":"#2f2f2f","background-selected":"#383838","background-subtle-selected":"#333","foreground-selected":"#e6e6e6","stroke-selected":"#e6e6e6","code-header":"#404040","code-block":"#2f2f2f","control-border":"#d2d2d2","control-border-bottom":"#e6e6e6","inline-code":"#404040","code-highlight-background":"#294903","visited":"#ac7ee1","score-low-off":"hsla(0deg,100%,33%,0.7)","score-low":"#b62626","score-medium-off":"hsla(44deg,100%,50%,0.3)","score-medium":"#ffcb3f","score-high-off":"hsla(120deg,37%,45%,0.7)","score-high":"#489d48","hyperlink":"#75b6e7","primary-base":"#75b6e7","primary-background":"#004173","primary-background-hover":"#082338","primary-background-selected":"#002c4e","primary-foreground-selected":"#77b7f7","primary-foreground-selected-invert":"#fff","primary-selected":"#0f548c","primary-stroke-selected":"#77b7f7","primary-background-glow-high-contrast":"#004173","primary-dark":"#9ccbee","primary-dark-hover":"#9ccbee","primary-hover":"#278cda","primary-active":"#2886de","primary-box-shadow":"hsla(206deg,100%,35%,0.3)","primary-invert":"#000","secondary-base":"#757575","secondary-background":"#404040","secondary-background-hover":"#292929","secondary-background-selected":"#383838","secondary-foreground-selected":"#e6e6e6","secondary-foreground-selected-invert":"#e6e6e6","secondary-selected":"#e0e0e0","secondary-stroke-selected":"#e6e6e6","secondary-background-glow-high-contrast":"#404040","secondary-dark":"#e6e6e6","secondary-dark-hover":"#8e8e8e","secondary-hover":"#8e8e8e","secondary-active":"#a2a2a2","secondary-box-shadow":"hsla(0deg,0%,0%,0.7)","secondary-invert":"#fff","tertiary-base":"#404040","tertiary-background":"#171717","tertiary-background-hover":"#505050","tertiary-background-selected":"#70819f","tertiary-foreground-selected":"#061329","tertiary-foreground-selected-invert":"#fff","tertiary-selected":"#70819f","tertiary-stroke-selected":"#061329","tertiary-background-glow-high-contrast":"#171717","tertiary-dark":"#e6e6e6","tertiary-dark-hover":"#8e8e8e","tertiary-hover":"#505050","tertiary-active":"#757575","tertiary-box-shadow":"hsla(206deg,100%,35%,0.3)","tertiary-invert":"#fff","success-base":"#7cbb7b","success-background":"#054b16","success-background-hover":"#107c10","success-background-selected":"#094509","success-foreground-selected":"#a7e3a5","success-foreground-selected-invert":"#fff","success-selected":"#00723b","success-stroke-selected":"#a7e3a5","success-background-glow-high-contrast":"#054b16","success-dark":"#dff6dd","success-dark-hover":"#7cbb7b","success-hover":"#489d48","success-active":"#7cbb7b","success-box-shadow":"hsla(120deg,37%,45%,0.7)","success-invert":"#000","info-base":"#9970d3","info-background":"#3b2e58","info-background-hover":"#8661c5","info-background-selected":"#201843","info-foreground-selected":"#efd9fd","info-foreground-selected-invert":"#201843","info-selected":"#d59dff","info-stroke-selected":"#efd9fd","info-background-glow-high-contrast":"#3b2e58","info-dark":"#efd9fd","info-dark-hover":"#d59dff","info-hover":"#ac7ee1","info-active":"#d59dff","info-box-shadow":"hsla(251deg,47%,18%,0.7)","info-invert":"#000","warning-base":"#f7630c","warning-background":"#4a1e04","warning-background-hover":"#7a2101","warning-background-selected":"#411200","warning-foreground-selected":"#fdcfb4","warning-foreground-selected-invert":"#000","warning-selected":"#ca5010","warning-stroke-selected":"#fdcfb4","warning-background-glow-high-contrast":"#7a2101","warning-dark":"#fdcfb4","warning-dark-hover":"#e9835e","warning-hover":"#ff8c00","warning-active":"#fdcfb4","warning-box-shadow":"hsla(24deg,100%,50%,0.7)","warning-invert":"#000","danger-base":"#e5a7a8","danger-background":"#630001","danger-background-hover":"#b62626","danger-background-selected":"#590815","danger-foreground-selected":"#eeacb2","danger-foreground-selected-invert":"#fff","danger-selected":"#bc2f32","danger-stroke-selected":"#eeacb2","danger-background-glow-high-contrast":"#630001","danger-dark":"#fde7e9","danger-dark-hover":"#d4797a","danger-hover":"#c54f4f","danger-active":"#d4797a","danger-box-shadow":"hsla(0deg,100%,33%,0.7)","danger-invert":"#000","facepile-red":"#c54f4f","facepile-teal":"#50e6ff","facepile-blue":"#278cda","gradient-text-purple":"#cd9bcf","gradient-text-blue":"#9ccbee","gradient-vivid-start":"#b84dc6","gradient-vivid-end":"#75b6e7"},"high-contrast":{"text":"#fff","text-subtle":"#fff","text-invert":"#000","text-glow-high-contrast":"#ff0","box-shadow-light":"hsla0deg,0%,0%,0.11)","box-shadow-medium":"hsla(0deg,0%,0%,0.13)","box-shadow-heavy":"hsla(0deg,0%,0%,0.18)","box-shadow-extra-heavy":"hsla(0deg,0%,0%,0.22)","overlay":"#404040","overlay-invert":"#fff","body-background":"#000","body-background-accent":"#000","body-background-medium":"#000","alternate-background":"#fff","alternate-background-medium":"#fff","border":"#fff","border-accent":"#fff","border-white-high-contrast":"#fff","border-yellow-high-contrast":"#ff0","card-background":"#000","table-header":"#505050","table-row":"#000","table-row-header":"#171717","table-border-dark":"#fff","hover-base":"#ff0","hover-invert":"#000","background-selected":"#000","background-subtle-selected":"#000","foreground-selected":"#c7c7c7","stroke-selected":"#fd0","code-header":"#000","code-block":"#000","control-border":"#fff","control-border-bottom":"#fff","inline-code":"#2f2f2f","code-highlight-background":"#0b6413","visited":"#3cff00","score-low-off":"#a80000","score-low":"#fde7e9","score-medium-off":"hsla(44deg,100%,50%,0.7)","score-medium":"#ffe79f","score-high-off":"#107c10","score-high":"#dff6dd","hyperlink":"#ff0","primary-base":"#ff0","primary-background":"#000","primary-background-hover":"#ff3","primary-background-glow-high-contrast":"#ff0","primary-background-selected":"#000","primary-foreground-selected":"#fd0","primary-foreground-selected-invert":"#000","primary-selected":"#fd0","primary-stroke-selected":"#fd0","primary-dark":"#ff0","primary-dark-hover":"#000","primary-hover":"#ff3","primary-active":"#ff3","primary-box-shadow":"#fff","primary-invert":"#000","secondary-base":"#e6e6e6","secondary-background":"#000","secondary-background-hover":"#ff3","secondary-background-glow-high-contrast":"#505050","secondary-background-selected":"#000","secondary-foreground-selected":"#c7c7c7","secondary-foreground-selected-invert":"#c7c7c7","secondary-selected":"#c7c7c7","secondary-stroke-selected":"#fd0","secondary-dark":"#e6e6e6","secondary-dark-hover":"#000","secondary-hover":"#d2d2d2","secondary-active":"#d2d2d2","secondary-box-shadow":"#e6e6e6","secondary-invert":"#000","tertiary-base":"#fff","tertiary-background":"#000","tertiary-background-hover":"#bdbdbd","tertiary-background-selected":"#70819f","tertiary-foreground-selected":"#061329","tertiary-foreground-selected-invert":"#fff","tertiary-selected":"#70819f","tertiary-stroke-selected":"#061329","tertiary-background-glow-high-contrast":"#fff","tertiary-dark":"#fff","tertiary-dark-hover":"#e6e6e6","tertiary-hover":"#e6e6e6","tertiary-active":"#e6e6e6","tertiary-box-shadow":"#fff","tertiary-invert":"#000","success-base":"#7cbb7b","success-background":"#000","success-background-hover":"#acd7aa","success-background-selected":"#000","success-foreground-selected":"#4da64d","success-foreground-selected-invert":"#000","success-selected":"#4da64d","success-stroke-selected":"#4da64d","success-background-glow-high-contrast":"#7cbb7b","success-dark":"#acd7aa","success-dark-hover":"#7cbb7b","success-hover":"#acd7aa","success-active":"#acd7aa","success-box-shadow":"#fff","success-invert":"#000","info-base":"#e0b7fe","info-background":"#000","info-background-hover":"#e0b7fe","info-background-selected":"#000","info-foreground-selected":"#efd9fd","info-foreground-selected-invert":"#000","info-selected":"#d59dff","info-stroke-selected":"#efd9fd","info-background-glow-high-contrast":"#e0b7fe","info-dark":"#efd9fd","info-dark-hover":"#d59dff","info-hover":"#efd9fd","info-active":"#efd9fd","info-box-shadow":"#fff","info-invert":"#000","warning-base":"#faa06b","warning-background":"#000","warning-background-hover":"#fdf6f3","warning-background-selected":"#000","warning-foreground-selected":"#f4bfab","warning-foreground-selected-invert":"#000","warning-selected":"#f4bfab","warning-stroke-selected":"#f4bfab","warning-background-glow-high-contrast":"#ffddb3","warning-dark":"#faa06b","warning-dark-hover":"#fdcfb4","warning-hover":"#efc4ad","warning-active":"#fff9f5","warning-box-shadow":"#fff","warning-invert":"#000","danger-base":"#e5a7a8","danger-background":"#000","danger-background-hover":"#e5a7a8","danger-background-selected":"#000","danger-foreground-selected":"#e37d80","danger-foreground-selected-invert":"#000","danger-selected":"#e37d80","danger-stroke-selected":"#e37d80","danger-background-glow-high-contrast":"#e5a7a8","danger-dark":"#fde7e9","danger-dark-hover":"#d4797a","danger-hover":"#fde7e9","danger-active":"#fde7e9","danger-box-shadow":"#fff","danger-invert":"#000","facepile-red":"#d4797a","facepile-teal":"#7becff","facepile-blue":"#75b6e7","gradient-text-purple":"#fff","gradient-text-blue":"#fff","gradient-vivid-start":"#fff","gradient-vivid-end":"#fff"}}}},"typography":{"name":"typography","location":"/css/src/tokens/typography.scss","tokens":{"$document-font-size":"16px","$font-size-9":"0.75rem","$font-size-8":"0.875rem","$font-size-7":"1rem","$font-size-6":"1.125rem","$font-size-5":"1.25rem","$font-size-4":"1.5rem","$font-size-3":"1.75rem","$font-size-2":"2.125rem","$font-size-1":"2.5rem","$font-size-0":"3.375rem","$weight-light":"100","$weight-semilight":"200","$weight-normal":"400","$weight-semibold":"600","$weight-bold":"700","$letter-spacing-medium":"0.125rem","$letter-spacing-wide":"0.225rem","$line-height-normal":"1.3"}},"z-index":{"name":"z-index","location":"/css/src/tokens/z-index.scss","tokens":{"$zindex-active":"1","$zindex-hover":"2","$zindex-focus":"3","$zindex-multi":"4","$zindex-dropdown":"1000","$zindex-sticky":"1020","$zindex-fixed":"1030","$zindex-modal-backdrop":"1040","$zindex-modal":"1050","$zindex-popover":"1060","$zindex-tooltip":"1070","$zindex-stretched-link":"1"}}}');


const $7095f0ec81935327$export$94ec4826144972dd = (0, (/*@__PURE__*/$parcel$interopDefault($e9aea353ec7e87a3$exports)));


let $f78667648d019a86$export$f89dfc8082866bac = "light";
function $f78667648d019a86$var$isTheme(value) {
    if (value === "light" || value === "dark" || value === "high-contrast") return true;
    return false;
}
const $f78667648d019a86$export$d9a33280f07116d9 = Object.keys((0, $7095f0ec81935327$export$94ec4826144972dd).themes.tokens.$themes);
const $f78667648d019a86$export$d5cd4a3428200c7d = $f78667648d019a86$export$d9a33280f07116d9.reduce((themeInfo, themeName)=>{
    themeInfo[themeName] = {
        documentClass: `theme-${themeName}`,
        name: themeName
    };
    return themeInfo;
}, {});
const $f78667648d019a86$export$c1c0562ec8379000 = $f78667648d019a86$export$d9a33280f07116d9.map((theme)=>$f78667648d019a86$export$d5cd4a3428200c7d[theme].documentClass);
function $f78667648d019a86$export$dacf863dec39215c(current) {
    const i = $f78667648d019a86$export$d9a33280f07116d9.findIndex((item)=>item === current) || 0;
    const next = i < 2 ? i + 1 : 0;
    // eslint-disable-next-line security/detect-object-injection
    return $f78667648d019a86$export$d9a33280f07116d9[next];
}
function $f78667648d019a86$export$49fdfce91965b93d(appliedTheme) {
    const htmlClassList = document.documentElement.classList;
    for (const docClass of $f78667648d019a86$export$c1c0562ec8379000)htmlClassList.remove(docClass);
    if ($f78667648d019a86$var$isTheme(appliedTheme)) // eslint-disable-next-line security/detect-object-injection
    htmlClassList.add($f78667648d019a86$export$d5cd4a3428200c7d[appliedTheme].documentClass);
}
function $f78667648d019a86$export$c97f82194d899591(appliedTheme) {
    return $f78667648d019a86$export$f89dfc8082866bac = appliedTheme;
}
function $f78667648d019a86$export$f2c36dbf83bbf605(theme) {
    (0, $84b1501969b8c5e9$export$c2ed3351cac403d1).setItem("theme", theme);
}
function $f78667648d019a86$export$4adfb56702530164(prefersDarkTheme = false) {
    // check for user selection
    const theme = (0, $84b1501969b8c5e9$export$c2ed3351cac403d1).getItem("theme");
    if (/^light|dark|high-contrast$/.test(theme)) return theme;
    // check for system dark preference
    if (prefersDarkTheme) return "dark";
    // default to light
    return "light";
}
function $f78667648d019a86$export$2e49b867b7a0847c(appliedTheme) {
    const previousTheme = $f78667648d019a86$export$f89dfc8082866bac;
    if (previousTheme === appliedTheme) return;
    $f78667648d019a86$export$c97f82194d899591(appliedTheme);
    $f78667648d019a86$export$49fdfce91965b93d(appliedTheme);
}
function $f78667648d019a86$export$4c47704ed26c13e8() {
    const theme = $f78667648d019a86$export$40f958b0338f176();
    $f78667648d019a86$export$2e49b867b7a0847c(theme);
    $f78667648d019a86$export$dc203973592e6a3f();
    // For use in screenshots
    window.setTheme = $f78667648d019a86$export$2e49b867b7a0847c;
}
function $f78667648d019a86$export$40f958b0338f176(prefersDarkTheme = (0, $227e784e47219e65$export$28075517a6f9175).matches) {
    const args = (0, $088734a1400ffdfa$export$66256f83798e5415)();
    // Themes can be forced with query string arguments.
    if (args.theme === "light" || args.theme === "dark" || args.theme === "high-contrast") return args.theme;
    return $f78667648d019a86$export$4adfb56702530164(prefersDarkTheme);
}
function $f78667648d019a86$export$dc203973592e6a3f() {
    window.addEventListener("click", ({ target: target })=>{
        const button = target instanceof Element && target.closest("[data-theme-cycle]");
        if (!button) return;
        const themeToApply = $f78667648d019a86$export$dacf863dec39215c($f78667648d019a86$export$f89dfc8082866bac);
        $f78667648d019a86$export$f2c36dbf83bbf605(themeToApply);
        $f78667648d019a86$export$2e49b867b7a0847c(themeToApply);
    });
}


function $d902694ff4349214$export$f4ff70372302e0aa() {
    const warningIcon = document.createElement("span");
    warningIcon.classList.add("warning-icon-container");
    warningIcon.setAttribute("data-warning-icon-container", "");
    warningIcon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="13" viewBox="0 0 15 13">
			<path d="M7.50781 0.109375C7.23698 0.109375 6.98177 0.182292 6.74219 0.328125C6.5026 0.46875 6.31771 0.658854 6.1875 
			0.898438L0.859375 10.7891C0.739583 11.013 0.679688 11.25 0.679688 11.5C0.679688 11.7031 0.721354 11.8958 0.804688 
			12.0781C0.882812 12.2604 0.989583 12.4193 1.125 12.5547C1.26042 12.6901 1.41927 12.7995 1.60156 12.8828C1.78385 12.9609 
			1.97656 13 2.17969 13H12.8359C13.0391 13 13.2318 12.9609 13.4141 12.8828C13.5911 12.7995 13.75 12.6901 13.8906 
			12.5547C14.026 12.4141 14.1354 12.2552 14.2188 12.0781C14.2969 11.8958 14.3359 11.7031 14.3359 11.5C14.3359 11.25 14.276 
			11.013 14.1562 10.7891L8.82812 0.898438C8.69792 0.658854 8.51302 0.46875 8.27344 0.328125C8.03385 0.182292 7.77865 0.109375 
			7.50781 0.109375ZM7.50781 9.75C7.40885 9.75 7.3151 9.77083 7.22656 9.8125C7.13802 9.85417 7.0599 9.91146 6.99219 
			9.98438C6.91927 10.0521 6.86198 10.1302 6.82031 10.2188C6.77865 10.3073 6.75781 10.401 6.75781 10.5C6.75781 10.599 
			6.77865 10.6927 6.82031 10.7812C6.86198 10.8698 6.91927 10.9505 6.99219 11.0234C7.0599 11.0911 7.13802 11.1458 7.22656 
			11.1875C7.3151 11.2292 7.40885 11.25 7.50781 11.25C7.60677 11.25 7.70052 11.2292 7.78906 11.1875C7.8776 11.1458 7.95833 
			11.0911 8.03125 11.0234C8.09896 10.9505 8.15365 10.8698 8.19531 10.7812C8.23698 10.6927 8.25781 10.599 8.25781 10.5C8.25781 
			10.401 8.23698 10.3073 8.19531 10.2188C8.15365 10.1302 8.09896 10.0521 8.03125 9.98438C7.95833 9.91146 7.8776 9.85417 
			7.78906 9.8125C7.70052 9.77083 7.60677 9.75 7.50781 9.75ZM7.50781 1.10938C7.61198 1.10938 7.70312 1.13802 7.78125 
			1.19531C7.85417 1.2526 7.91927 1.32292 7.97656 1.40625C8.03385 1.48958 8.08333 1.58073 8.125 1.67969C8.16667 1.77344 
			8.20833 1.85677 8.25 1.92969C8.32812 2.08073 8.46094 2.32812 8.64844 2.67188C8.83073 3.01562 9.04948 3.41667 9.30469 
			3.875C9.5599 4.33333 9.83594 4.83333 10.1328 5.375C10.4297 5.91667 10.7266 6.46094 11.0234 7.00781C11.3203 7.55469 
			11.6094 8.08594 11.8906 8.60156C12.1667 9.11719 12.4141 9.58073 12.6328 9.99219C12.8464 10.4036 13.0182 10.7448 13.1484 
			11.0156C13.2734 11.2812 13.3359 11.4427 13.3359 11.5C13.3359 11.6354 13.2865 11.7526 13.1875 11.8516C13.0885 11.9505 
			12.9714 12 12.8359 12H2.17969C2.04427 12 1.92708 11.9505 1.82812 11.8516C1.72917 11.7526 1.67969 11.6354 1.67969 
			11.5C1.83073 11.125 2.0026 10.763 2.19531 10.4141C2.38281 10.0651 2.57031 9.71094 2.75781 9.35156C3.0026 8.89323 3.24479 
			8.4349 3.48438 7.97656C3.71875 7.51302 3.95833 7.05208 4.20312 6.59375C4.45312 6.11979 4.70312 5.65104 4.95312 
			5.1875C5.20312 4.71875 5.45312 4.2474 5.70312 3.77344C5.88542 3.4401 6.06771 3.10938 6.25 2.78125C6.42708 2.44792 
			6.61198 2.11719 6.80469 1.78906C6.84635 1.71615 6.88802 1.64583 6.92969 1.57812C6.97135 1.50521 7.01823 1.4375 7.07031 
			1.375C7.1276 1.30208 7.1901 1.23958 7.25781 1.1875C7.32552 1.13542 7.40885 1.10938 7.50781 1.10938ZM7.00781 
			9H8.00781V4H7.00781V9Z"/>
			</svg>`;
    document.querySelectorAll("form")?.forEach((form)=>{
        form.addEventListener("form-validating", (e)=>{
            e.preventDefault();
            const container = form.querySelector("[data-form-error-container]");
            const warningIconContainer = container?.firstElementChild?.querySelector("[data-warning-icon-container]");
            if (!warningIconContainer) container?.firstElementChild?.prepend(warningIcon);
        }, {
            capture: true
        });
        form.addEventListener("beforesubmit", (e)=>{
            e.preventDefault();
            if (form.hasAttribute("test-async-before-submit")) {
                const customEvent = e;
                if (customEvent.detail) customEvent.detail.callback = async ()=>{
                    await new Promise((resolve)=>setTimeout(resolve, 3000));
                    const formData = new FormData(form);
                    $d902694ff4349214$var$populateSubmittedFormData(formData, form);
                };
            } else {
                const formData = new FormData(form);
                $d902694ff4349214$var$populateSubmittedFormData(formData, form);
            }
        }, {
            capture: true
        });
    });
}
function $d902694ff4349214$var$populateSubmittedFormData(formData, form) {
    const submittedFormDataExample = form.querySelector(".submitted-form-data-example");
    const dataMessage = `The following data will be submitted: ${JSON.stringify(Object.fromEntries(formData), null, 2)}`;
    if (submittedFormDataExample?.firstChild) submittedFormDataExample.firstChild.textContent = dataMessage;
    else {
        const message = document.createElement("p");
        message.classList.add("padding-xs");
        message.textContent = dataMessage;
        submittedFormDataExample?.appendChild(message);
    }
}


function $4e0192595c049343$export$bec8e2005d807978() {
    window.addEventListener("click", ({ target: target })=>{
        const dismissButton = target instanceof Element && target.closest("[data-dismiss]");
        if (!dismissButton) return;
        const dismissTarget = dismissButton.closest("[data-dismissable]");
        if (!dismissTarget) return;
        $4e0192595c049343$var$dismissElement(dismissTarget);
    });
}
function $4e0192595c049343$var$dismissElement(dismissTarget) {
    const dismissAnimation = dismissTarget.getAttribute("data-dismiss-animation");
    if (dismissAnimation) {
        dismissTarget.addEventListener("animationend", ()=>{
            dismissTarget.remove();
        });
        switch(dismissAnimation){
            case "slide-up":
                dismissTarget.classList.add("animation-slide-up");
                break;
            case "fade":
                dismissTarget.classList.add("animation-fade");
                break;
        }
    } else dismissTarget.remove();
    // Notification about content update occurrence.
    window.dispatchEvent(new CustomEvent("dismiss-content-update"));
}


/* eslint-disable @typescript-eslint/no-use-before-define */ function $c1991f537e9ddabd$export$7ae0af140e650b26(container = document.body) {
    container.addEventListener("toggle", (event)=>{
        const targetPopover = event.target instanceof Element && event.target.closest("details.popover") || event.target instanceof Element && event.target.shadowRoot?.activeElement?.closest("details.popover");
        if (!targetPopover || !targetPopover.open) return;
        const keyHandler = (event)=>{
            if (event.key === "Escape") closePopovers();
        };
        const checkTarget = (event)=>{
            if (!(event.target instanceof Element)) return;
            if (!targetPopover?.contains(event.target)) closePopovers();
            if (event.type === "click" && event.target.closest("[data-popover-close]")) closePopovers();
        };
        const blurHandler = ()=>{
            if (document.activeElement?.nodeName?.toLowerCase() === "iframe") closePopovers();
        };
        const closePopovers = ()=>{
            container.removeEventListener("focus", checkTarget, true);
            container.removeEventListener("click", checkTarget);
            container.removeEventListener("touchstart", checkTarget);
            container.removeEventListener("keydown", keyHandler);
            window.removeEventListener("blur", blurHandler);
            if (targetPopover?.open) targetPopover.removeAttribute("open");
        };
        container.addEventListener("focus", checkTarget, true);
        container.addEventListener("click", checkTarget);
        container.addEventListener("touchstart", checkTarget);
        container.addEventListener("keydown", keyHandler);
        window.addEventListener("blur", blurHandler);
    }, true);
}


let $0ff9b3ba2ca1da31$var$snapScrollUpdating = false;
function $0ff9b3ba2ca1da31$export$4b58943ac722c0ed() {
    // slide card when the button is clicked
    $0ff9b3ba2ca1da31$var$initSnapScrollClickListeners();
    // update when slide scrolls into the view
    const snapScrolls = Array.from(document.querySelectorAll("[data-snap-scroll]"));
    for (const snapScroll of snapScrolls)$0ff9b3ba2ca1da31$export$3f1703e6cdd6d4ee(snapScroll);
}
function $0ff9b3ba2ca1da31$export$3f1703e6cdd6d4ee(element) {
    const slideContainer = element.querySelector("[data-snap-scroll-slides]");
    if (!slideContainer) throw new Error('Your snap scroll element must contain a scrollable element with "data-snap-scroll-slides" attribute.');
    const slides = Array.from(slideContainer.querySelectorAll("[data-snap-scroll-slide]"));
    const options = {
        root: slideContainer,
        rootMargin: "0px",
        threshold: 0.8
    };
    const observer = new IntersectionObserver((entries)=>{
        if ($0ff9b3ba2ca1da31$var$snapScrollUpdating) return;
        if (entries[0].isIntersecting === true) {
            const step = entries[0].target.getAttribute("data-snap-scroll-slide");
            if (!step) throw new Error("The [data-snap-scroll-slide] clicked does not correspond to a [data-snap-scroll-nav-item]");
            const anchor = element.querySelector(`[data-snap-scroll-nav-item="${step}"]`);
            if (!anchor) throw new Error("Anchor missing from snap scroll container");
            $0ff9b3ba2ca1da31$var$updatePaginationState(element, anchor);
        }
    }, options);
    slides.forEach((slide)=>observer.observe(slide));
}
function $0ff9b3ba2ca1da31$var$initSnapScrollClickListeners() {
    window.addEventListener("click", (event)=>{
        const target = event.target instanceof Element && event.target.closest("[data-snap-scroll-nav-item]");
        if (!target) return;
        const parentElement = target.closest("[data-snap-scroll]");
        if (!parentElement) return;
        const snapScrollId = target.dataset.snapScrollNavItem;
        if (!snapScrollId) throw new Error('You need to add a value to the parent of your snap scroll: [data-snap-scroll="id-goes-here")');
        $0ff9b3ba2ca1da31$var$snapScrollUpdating = true;
        event.preventDefault();
        const slide = parentElement.querySelector(`[data-snap-scroll-slide="${snapScrollId}"]`);
        $0ff9b3ba2ca1da31$var$updatePaginationState(parentElement, target);
        slide.scrollIntoView({
            behavior: "auto",
            block: "nearest",
            inline: "start"
        });
        setTimeout(()=>$0ff9b3ba2ca1da31$var$snapScrollUpdating = false, 500);
    });
}
function $0ff9b3ba2ca1da31$var$updatePaginationState(parentElement, activeAnchor) {
    // remove is current from all anchors in this container
    const anchors = Array.from(parentElement.querySelectorAll("[data-snap-scroll-nav-item]"));
    for (const a of anchors)a.classList.remove("is-current");
    // add one back
    activeAnchor.classList.add("is-current");
}


let $48e0439ed1d493cd$var$nextId = 0;
function $48e0439ed1d493cd$export$cfe7bad09682ff51() {
    return `bx-${$48e0439ed1d493cd$var$nextId++}`;
}
function $48e0439ed1d493cd$export$4e2d767d23cc93ee(str) {
    return str.replace(/-./g, (x)=>x[1].toUpperCase());
}


const $63d6648ccf2da550$export$74d1e9f4105a478b = {
    contentHasChanged: "Content has changed, please reload the page to get the latest changes.",
    inputGroupRequired: "At least one selection for {inputGroup} is required.",
    inputMaxLength: "{inputLabel} cannot be longer than {maxLength} characters.",
    inputMinLength: "{inputLabel} must be at least {minLength} characters.",
    inputRequired: "{inputLabel} is required.",
    notAuthenticated: "You are not authenticated. Please refresh the page and try again. If this issue persists, please log out and log back in.",
    notAuthorized: "You are not authorized to make this response. If you believe this to be in error, please refresh the page and try again.",
    pleaseFixTheFollowingIssues: "Please fix the following issues to continue:",
    thereAreNoEditsToSubmit: "There are no edits to submit.",
    tooManyRequests: "You have sent too many requests. Please wait a few minutes and try again.",
    weEncounteredAnUnexpectedError: "We encountered an unexpected error. Please try again later. If this issue continues, please contact site support."
};
class $63d6648ccf2da550$export$eff824212e04ca3f extends HTMLElement {
    constructor(){
        super();
        this.submitting = false;
        this.initialData = new FormData();
        this.toDispose = [];
        this.isDirty = false;
        this.commitTimeout = 0;
        this.locStrings = $63d6648ccf2da550$export$74d1e9f4105a478b;
        this.validators = [
            this.validateMinLength.bind(this),
            this.validateRequired.bind(this),
            this.validateMaxLength.bind(this)
        ];
        this.commit = (event)=>{
            if (!$63d6648ccf2da550$var$isValueElement(event.target, this.form) || !event.target?.form || event.target?.form !== this.parentElement) return;
            clearTimeout(this.commitTimeout);
            if (event.type === "change") $63d6648ccf2da550$var$normalizeInputValue(event.target);
            this.setDirty();
        };
        this.locStrings = this.locStrings;
    }
    get canSave() {
        return this.isDirty || this.isNew;
    }
    get form() {
        return this.closest(`form`);
    }
    // disable browser message when leaving page
    get hideUnloadMessage() {
        return this.hasAttribute("nounload");
    }
    // use the new attribute when you want to ignore isDirty validation (for example, if the only user action on the form is to click a button)
    get isNew() {
        return this.hasAttribute("new");
    }
    // Currently only used for Feedback form-behavior.
    // Use the `nosubmit` attibute to bypass automatic form submission if a form contains a body but does not need to send a POST request.
    get noSubmit() {
        return this.hasAttribute("nosubmit");
    }
    connectedCallback() {
        const form = this.parentElement;
        if (!(form instanceof HTMLFormElement)) return;
        this.locStrings = this.getLocaleStrings();
        form.setAttribute("novalidate", "");
        const errorSummaryContainer = document.createElement("div");
        errorSummaryContainer.setAttribute("data-form-error-container", "");
        if (form.hasAttribute("data-hide-validation-banner")) errorSummaryContainer.hidden = true;
        this.insertAdjacentElement("afterend", errorSummaryContainer);
        this.initialData = new FormData(form);
        if (this.ownerDocument.readyState === "loading") this.ownerDocument.addEventListener("readystatechange", ()=>this.initialData = new FormData(form));
        this.subscribe(form, "input", this);
        this.subscribe(form, "change", this);
        this.subscribe(form, "submit", this);
        this.subscribe(window, "beforeunload", this);
    }
    disconnectedCallback() {
        for (const dispose of this.toDispose)dispose();
    }
    getLocaleStrings() {
        const formLocaleStrings = Array.from(this.attributes).filter((a)=>a.name.startsWith("loc-")).reduce((map, a)=>{
            map[(0, $48e0439ed1d493cd$export$4e2d767d23cc93ee)(a.name.substring(4))] = a.value;
            return map;
        }, {});
        return Object.assign({}, $63d6648ccf2da550$export$74d1e9f4105a478b, formLocaleStrings);
    }
    subscribe(target, type, listener) {
        target.addEventListener(type, listener);
        this.toDispose.push(()=>target.removeEventListener(type, listener));
    }
    setDirty() {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        const initial = new URLSearchParams(this.initialData).toString();
        const current = new URLSearchParams(// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        new FormData(this.parentElement)).toString();
        this.isDirty = current !== initial;
    }
    handleEvent(event) {
        switch(event.type){
            case "submit":
                this.handleSubmitEvent(event);
                break;
            case "beforeunload":
                this.handleUnloadEvent(event);
                break;
            case "input":
                this.clearValidationErrors(event.target);
                this.scheduleCommit(event);
                break;
            case "change":
                this.clearValidationErrors(event.target);
                this.commit(event);
                break;
            default:
                throw new Error(`Unexpected event ${event.type}.`);
        }
    }
    navigate(href) {
        const navigate = $63d6648ccf2da550$export$7aa55fd9657ff73(href, this.getAttribute("navigation"));
        return navigate;
    }
    scheduleCommit(event) {
        clearTimeout(this.commitTimeout);
        setTimeout(this.commit, 300, event);
    }
    async handleUnloadEvent(event) {
        this.setDirty();
        if (!this.isDirty || this.hideUnloadMessage) return;
        event.preventDefault();
        event.returnValue = "You have unsaved work."; // browser overrides this text
    }
    async handleSubmitEvent(event) {
        event.preventDefault();
        if (this.submitting) return;
        const form = event.currentTarget;
        // reject the submit if no edits have been made (overridable with the new attribute)
        if (!this.canSave) {
            this.showNoChangesMessage(form);
            const validationErrorEvent = new CustomEvent("form-validating", {
                detail: {
                    form: form
                },
                bubbles: true
            });
            this.dispatchEvent(validationErrorEvent);
            return;
        }
        let isNavigating = false;
        try {
            this.submitting = true;
            $63d6648ccf2da550$var$setBusySubmitButton(event, form, this.submitting);
            const result = await this.validateForm(form);
            if (!result.valid || this.noSubmit) return;
            const url = $63d6648ccf2da550$var$handleSubmitButtonAction(event) ?? form.action;
            const params = new URL(url).searchParams;
            const formData = new FormData(form);
            // set and read headers:
            const headers = new Headers();
            headers.set("content-type", "application/json");
            for (const { name: name, value: value } of this.attributes)if (name.startsWith("header-")) headers.set(name.substring(7), value);
            // form.method does not support PUT or DELETE events, use method queryParam if it exists.
            const method = params.get("_method") || form.method || "GET";
            const init = {
                method: method,
                body: JSON.stringify(Object.fromEntries(formData)),
                headers: headers
            };
            const beforeSubmitEvent = new CustomEvent("beforesubmit", {
                detail: {
                    url: url,
                    init: init,
                    form: form,
                    callback: async ()=>{}
                },
                bubbles: true,
                cancelable: true
            });
            const cancelled = !this.dispatchEvent(beforeSubmitEvent);
            if (beforeSubmitEvent.detail.callback) try {
                await beforeSubmitEvent.detail.callback();
            } catch (error) {
                // on error return and allow for custom error handling
                return;
            }
            if (cancelled) return;
            const request = new Request(beforeSubmitEvent.detail.url, beforeSubmitEvent.detail.init);
            const response = await fetch(request);
            if (response.ok) {
                this.removeAttribute("new");
                this.initialData = formData;
                this.setDirty();
                this.dispatchEvent(new CustomEvent("aftersubmit", {
                    detail: {
                        request: request,
                        response: response
                    },
                    bubbles: true
                }));
                isNavigating = this.navigate(response.headers.get("location") ?? this.getAttribute("navigation-href"));
            } else {
                const { errorAlert: errorAlert, errorList: errorList } = this.getErrorAlert(form);
                const errorText = document.createElement("li");
                errorText.innerText = this.locStrings.weEncounteredAnUnexpectedError;
                // custom text for version mismatch
                if (response.status === 401) errorText.innerText = this.locStrings.notAuthenticated;
                if (response.status === 403) errorText.innerText = this.locStrings.notAuthorized;
                if (response.status === 412) errorText.innerText = this.locStrings.contentHasChanged;
                if (response.status === 429) errorText.innerText = this.locStrings.tooManyRequests;
                this.dispatchEvent(new CustomEvent("submission-error", {
                    detail: {
                        form: form,
                        request: request,
                        response: response
                    },
                    bubbles: true
                }));
                errorList.appendChild(errorText);
                errorAlert.hidden = false;
                errorAlert.focus();
            }
        } finally{
            this.submitting = isNavigating;
            $63d6648ccf2da550$var$setBusySubmitButton(event, form, this.submitting);
        }
    }
    createErrorAlert(form) {
        const formLayout = form.querySelector("[data-form-error-container]") || form;
        const alertId = (0, $48e0439ed1d493cd$export$cfe7bad09682ff51)();
        const errorAlert = document.createElement("div");
        errorAlert.className = "help help-danger background-color-danger-light border border-color-danger border-radius padding-xs margin-bottom-sm";
        errorAlert.setAttribute("data-form-error-alert", "");
        errorAlert.setAttribute("role", "alert");
        errorAlert.setAttribute("aria-labelledby", alertId);
        errorAlert.setAttribute("tabindex", "-1");
        errorAlert.hidden = true;
        const alertText = document.createElement("p");
        alertText.id = alertId;
        alertText.className = "font-size-md font-weight-semibold margin-bottom-xs display-inline-flex";
        alertText.innerText = this.locStrings.pleaseFixTheFollowingIssues;
        const errorList = document.createElement("ul");
        errorList.setAttribute("aria-label", "Validation errors");
        errorList.classList.add("margin-left-sm-tablet");
        errorAlert.append(alertText, errorList);
        formLayout.appendChild(errorAlert);
        return {
            errorAlert: errorAlert,
            errorList: errorList
        };
    }
    getErrorAlert(form) {
        const errorAlert = form.querySelector("[data-form-error-alert]");
        if (errorAlert) return {
            errorAlert: errorAlert,
            errorList: errorAlert.lastElementChild
        };
        return this.createErrorAlert(form);
    }
    validateRequired(input, label) {
        if (input.validity.valueMissing) return this.locStrings.inputRequired.replace("{inputLabel}", customElements.get(input.localName) || input.type === "radio" ? `A selection for "${label}"` : label);
        return null;
    }
    validateMinLength(input, label) {
        if ((input instanceof HTMLTextAreaElement || input instanceof HTMLInputElement) && (input.validity.tooShort || input.minLength > 0 && input.value.length < input.minLength)) return this.locStrings.inputMinLength.replace("{inputLabel}", label).replace("{minLength}", input.minLength.toString());
        return null;
    }
    validateMaxLength(input, label) {
        if ((input instanceof HTMLTextAreaElement || input instanceof HTMLInputElement) && (input.validity.tooLong || input.maxLength > 0 && input.value.length > input.maxLength)) return this.locStrings.inputMaxLength.replace("{inputLabel}", label).replace("{maxLength}", input.maxLength.toString());
        return null;
    }
    async validateForm(form, displayValidity = true, scope = form) {
        const errors = [];
        const { errorAlert: errorAlert, errorList: errorList } = this.getErrorAlert(form);
        if (displayValidity || form.hasAttribute("data-hide-validation-banner")) {
            errorAlert.hidden = true;
            errorList.innerHTML = "";
        }
        const customElements1 = $63d6648ccf2da550$export$6fdbe88c041d855d(form);
        for (const input of [
            ...form.elements,
            ...customElements1
        ]){
            if (!scope.contains(input) || !$63d6648ccf2da550$var$canValidate(input, form)) continue;
            // Apply validation to the first radio in a group
            // This is to prevent duplicate validation messages for each radio in a group
            if (input.type === "radio") {
                const radioGroup = form.querySelectorAll(`input[name="${input.name}"]`);
                if (radioGroup.length > 1 && radioGroup[0] !== input) continue;
            }
            if (input.hasAttribute("aria-hidden") === true) continue;
            // Don't check combobox
            if (input.getAttribute("role") === "combobox") continue;
            // Don't check elements that are part of markdown editor
            if (input.closest("docs-markdown-editor")) continue;
            if (input.hasAttribute("data-skip-validation")) {
                const validationErrorEvent = new CustomEvent("form-validating", {
                    detail: {
                        errors: errors,
                        form: form
                    },
                    bubbles: true
                });
                this.dispatchEvent(validationErrorEvent);
                continue;
            }
            const isCustomElement = !!customElements1.find((el)=>el === input);
            this.runBasicValidation(input, displayValidity, errors, errorList, isCustomElement);
            const validationErrorEvent = new CustomEvent("form-validating", {
                detail: {
                    errors: errors,
                    form: form
                },
                bubbles: true
            });
            this.dispatchEvent(validationErrorEvent);
        }
        if (errors.length === 0) return {
            valid: true
        };
        if (displayValidity) {
            errorAlert.hidden = false;
            errorAlert.focus();
        }
        return {
            valid: false,
            errors: errors
        };
    }
    clearValidationErrors(target) {
        if (!$63d6648ccf2da550$var$canValidate(target, this.form)) return;
        $63d6648ccf2da550$var$clearInputErrorBorder(target);
        $63d6648ccf2da550$export$e0ddcd48746f2dd9(target, "");
        $63d6648ccf2da550$export$2c9b3f539cb25b05(target).classList.remove("errored");
        if (target.form) {
            const { errorAlert: errorAlert, errorList: errorList } = this.getErrorAlert(target.form);
            errorList.querySelectorAll(`a[href="#${target.id}"]`).forEach((a)=>a.parentElement?.remove());
            // clear no edits error if it exists as well
            errorList.querySelector("#no-edits-error")?.remove();
            if (!errorList.firstElementChild) errorAlert.hidden = true;
        }
        const clearValidationEvent = new CustomEvent("clear-validation-errors", {
            detail: {
                target: target
            },
            bubbles: true
        });
        this.dispatchEvent(clearValidationEvent);
    }
    showNoChangesMessage(form) {
        const { errorAlert: errorAlert, errorList: errorList } = this.getErrorAlert(form);
        if (errorList.childElementCount > 0) {
            while(errorList.firstChild)errorList.lastChild?.remove();
            // clear no edits error if it exists as well
            errorList.querySelector("#no-edits-error")?.remove();
        }
        const errorText = document.createElement("li");
        errorText.id = "no-edits-error";
        errorText.innerText = this.locStrings.thereAreNoEditsToSubmit;
        errorList.appendChild(errorText);
        errorAlert.hidden = false;
        errorAlert.focus();
    }
    runBasicValidation(input, displayValidity = true, errors, errorList, isCustomElement) {
        if (!$63d6648ccf2da550$var$canValidate(input, this.form)) return;
        const label = $63d6648ccf2da550$export$236350842f3cd9bc(input);
        const group = $63d6648ccf2da550$export$2c9b3f539cb25b05(input);
        for (const validator of this.validators){
            const message = validator(input, label);
            if (!message) {
                if (!isCustomElement) $63d6648ccf2da550$var$clearInputErrorBorder(input);
                continue;
            }
            errors.push({
                input: input,
                message: message
            });
            if (displayValidity) {
                if (!input.id) continue;
                $63d6648ccf2da550$export$e0ddcd48746f2dd9(input, message);
                group.classList.add("errored");
                const child = document.createElement("li");
                child.classList.add("margin-bottom-xs");
                const a = document.createElement("a");
                a.href = `#${input.id}`;
                a.textContent = message;
                a.classList.add("help", "help-danger");
                // ensure focus is set on the custom element
                a.addEventListener("click", (e)=>{
                    if (isCustomElement) {
                        const target = e.target.getAttribute("href");
                        if (target) document.querySelector(target).focus();
                    }
                });
                child.appendChild(a);
                errorList.appendChild(child);
                if (!isCustomElement) {
                    if (input.type === "checkbox") input.closest("label.checkbox")?.classList.add(`is-invalid`);
                    else if (input.type === "radio") input.closest("label.radio")?.classList.add(`is-invalid`);
                    else input.classList.add(`${input.localName}-danger`);
                }
            }
            break;
        }
    }
}
if (!window.customElements.get("form-behavior")) {
    window.FormBehaviorElement = $63d6648ccf2da550$export$eff824212e04ca3f;
    window.customElements.define("form-behavior", $63d6648ccf2da550$export$eff824212e04ca3f);
}
// Check if the required value related properties exist rather than an instance of a form related element.
function $63d6648ccf2da550$var$isValueElement(target, form) {
    const element = target;
    if (element) return element instanceof HTMLElement && "form" in element && element.form === form && "validity" in element && element.validity instanceof ValidityState && "value" in element && typeof element.value === "string" && "type" in element && typeof element.type === "string" && ![
        "button",
        "submit"
    ].includes(element.type);
    return false;
}
function $63d6648ccf2da550$var$normalizeInputValue(target) {
    if (target instanceof HTMLTextAreaElement) target.value = target.value.trim();
    else if (target instanceof HTMLInputElement && (target.type === "text" || target.type === "email")) target.value = target.value.trim();
}
function $63d6648ccf2da550$var$setBusySubmitButton(event, form, isLoading) {
    const submitter = event.submitter;
    Array.from(form.elements).forEach((element)=>{
        if (element instanceof HTMLButtonElement && element.type === "submit") {
            if (submitter && submitter === element) element.classList.toggle("is-loading", isLoading);
            else element.disabled = isLoading;
        }
    });
}
function $63d6648ccf2da550$export$236350842f3cd9bc(input) {
    let label = null;
    if (input.type === "radio") {
        const group = $63d6648ccf2da550$export$2c9b3f539cb25b05(input);
        const groupLabel = group.querySelector(".field-label");
        if (groupLabel) label = groupLabel.textContent;
        else label = input.getAttribute("aria-label");
    } else if (input.labels?.length) label = input.labels[0].textContent;
    else label = input.getAttribute("aria-label");
    if (!label) throw new Error(`${input.nodeName} name="${input.name}" id="${input.id}" has no associated label.`);
    return label.trim();
}
function $63d6648ccf2da550$export$2c9b3f539cb25b05(input) {
    const group = input.closest(".field");
    if (!group) throw new Error(`${input.nodeName} name="${input.name}" id="${input.id}" is not within a .field`);
    return group;
}
function $63d6648ccf2da550$export$52dd50fe747c85c8(input) {
    const body = input.closest(".field-body");
    if (!body) throw new Error(`${input.nodeName} name="${input.name}" id="${input.id}" is not within a .field-body`);
    return body;
}
function $63d6648ccf2da550$var$createErrorNote(input) {
    const note = document.createElement("p");
    note.id = (0, $48e0439ed1d493cd$export$cfe7bad09682ff51)();
    input.setAttribute("aria-describedby", `${note.id} ${input.getAttribute("aria-describedby") || ""}`);
    note.classList.add("field-error");
    note.setAttribute("data-field-error", "");
    $63d6648ccf2da550$export$52dd50fe747c85c8(input).after(note);
    return note;
}
function $63d6648ccf2da550$export$e0ddcd48746f2dd9(element, message) {
    const group = $63d6648ccf2da550$export$2c9b3f539cb25b05(element);
    const note = group.querySelector("[data-field-error]") || $63d6648ccf2da550$var$createErrorNote(element);
    note.textContent = message;
}
function $63d6648ccf2da550$var$canValidate(target, form) {
    return $63d6648ccf2da550$var$isValueElement(target, form) && target.type !== "hidden";
}
function $63d6648ccf2da550$export$7aa55fd9657ff73(href, navigationStep) {
    switch(navigationStep){
        case null:
            // do nothing.
            return false;
        case "follow":
            if (href) {
                location.href = href;
                return true;
            }
            return false;
        case "hash-reload":
            if (href) {
                const search = href.includes("?") ? "" : window.location.search;
                if (href !== search + window.location.hash) {
                    const state = history.state || {};
                    window.history.pushState(state, document.title, window.location.pathname + search + href); // prevents scrolling to spot until reload
                }
                location.reload();
                return true;
            }
            return false;
        case "replace":
            if (href) {
                location.replace(href);
                return true;
            }
            return false;
        case "reload":
            location.reload();
            return true;
        default:
            throw new Error(`Unexpected navigation attribute value.`);
    }
}
function $63d6648ccf2da550$export$6fdbe88c041d855d(form) {
    // Compare FormData with form.elements to find missing elements.
    const formData = Object.fromEntries(new FormData(form));
    const customElementList = [];
    const customElements1 = Object.keys(formData).filter((key)=>{
        return !form.elements.namedItem(key);
    });
    customElements1.forEach((name)=>{
        const element = form.querySelector(`[name="${name}"]`);
        if (element) customElementList.push(element);
    });
    return customElementList;
}
function $63d6648ccf2da550$var$clearInputErrorBorder(input) {
    if (input.type === "checkbox") input.closest("label.checkbox")?.classList.remove(`is-invalid`);
    else input.classList.remove(`${input.localName}-danger`);
}
function $63d6648ccf2da550$var$handleSubmitButtonAction(event) {
    const submitter = event.submitter;
    const formAction = submitter instanceof HTMLButtonElement && submitter.formAction !== window.location.href ? submitter.formAction : null;
    return formAction;
}


// This component is a copy, rename and extension of the library
// https://github.com/github/tab-container-element/releases/tag/v4.8.0
// eslint-disable-next-line @typescript-eslint/naming-convention
const $318d4e757804fac8$var$HTMLElement = globalThis.HTMLElement || null;
// Function to see if manual slots are supported and if not, manual assign the slot attribute
const $318d4e757804fac8$var$assignSlotWithFallback = "assign" in (globalThis.HTMLSlotElement?.prototype || {}) ? (slot, ...elements)=>{
    slot.assign(...elements);
} : (slot, ...elements)=>{
    const host = slot.getRootNode().host;
    for (const element of host.querySelectorAll(`[slot="${slot.name}"]`))element.removeAttribute("slot");
    for (const element of elements)element.setAttribute("slot", slot.name);
};
class $318d4e757804fac8$export$6a3733570e3be366 extends Event {
    constructor(type, { tabIndex: tabIndex, tab: tab, panel: panel, ...init }){
        super(type, init);
        this.#tabIndex = null;
        this.#panel = null;
        this.#tab = null;
        this.#tab = tab || null;
        this.#tabIndex = tabIndex || null;
        this.#panel = panel || null;
    }
    #tabIndex;
    get tabIndex() {
        return this.#tabIndex;
    }
    #panel;
    get panel() {
        return this.#panel;
    }
    #tab;
    get tab() {
        return this.#tab;
    }
}
class $318d4e757804fac8$export$d423894cc51549d0 extends $318d4e757804fac8$var$HTMLElement {
    static define(tag = "tab-container", registry = customElements) {
        registry.define(tag, this);
        return this;
    }
    get onChange() {
        return this.onTabContainerChange;
    }
    set onChange(listener) {
        this.onTabContainerChange = listener;
    }
    #onTabContainerChange;
    get onTabContainerChange() {
        return this.#onTabContainerChange;
    }
    set onTabContainerChange(listener) {
        if (this.#onTabContainerChange) this.removeEventListener("tab-container-change", this.#onTabContainerChange);
        this.#onTabContainerChange = typeof listener === "object" || typeof listener === "function" ? listener : null;
        if (typeof listener === "function") this.addEventListener("tab-container-change", listener);
    }
    #onTabContainerChanged;
    get onTabContainerChanged() {
        return this.#onTabContainerChanged;
    }
    set onTabContainerChanged(listener) {
        if (this.#onTabContainerChanged) this.removeEventListener("tab-container-changed", this.#onTabContainerChanged);
        this.#onTabContainerChanged = typeof listener === "object" || typeof listener === "function" ? listener : null;
        if (typeof listener === "function") this.addEventListener("tab-container-changed", listener);
    }
    get onChanged() {
        return this.onTabContainerChanged;
    }
    set onChanged(listener) {
        this.onTabContainerChanged = listener;
    }
    static{
        // eslint-disable-next-line @typescript-eslint/member-ordering
        this.observedAttributes = [
            "vertical"
        ];
    }
    get #tabList() {
        const wrapper = this.querySelector("[slot=tablist-wrapper]");
        if (wrapper?.closest(this.tagName) === this) return wrapper.querySelector("[role=tablist]");
        const slot = this.#tabListSlot;
        if (this.#tabListTabWrapper.hasAttribute("role")) return this.#tabListTabWrapper;
        else return slot.assignedNodes()[0];
    }
    get #tabListWrapper() {
        return this.shadowRoot.querySelector('slot[part="tablist-wrapper"]');
    }
    get #tabListTabWrapper() {
        return this.shadowRoot.querySelector('div[part="tablist-tab-wrapper"]');
    }
    get #beforeTabsSlot() {
        return this.shadowRoot.querySelector('slot[part="before-tabs"]');
    }
    get #afterTabsSlot() {
        return this.shadowRoot.querySelector('slot[part="after-tabs"]');
    }
    get #afterPanelsSlot() {
        return this.shadowRoot.querySelector('slot[part="after-panels"]');
    }
    get #tabListSlot() {
        return this.shadowRoot.querySelector('slot[part="tablist"]');
    }
    get #panelSlot() {
        return this.shadowRoot.querySelector('slot[part="panel"]');
    }
    get #tabs() {
        if (this.#tabListTabWrapper.matches("[role=tablist]")) return this.#tabListSlot.assignedNodes();
        return Array.from(this.#tabList?.querySelectorAll('[role="tab"]') || []).filter((tab)=>tab instanceof $318d4e757804fac8$var$HTMLElement && tab.closest(this.tagName) === this);
    }
    get activeTab() {
        return this.#tabs[this.selectedTabIndex];
    }
    get activePanel() {
        return this.#panelSlot.assignedNodes()[0];
    }
    get vertical() {
        return this.#tabList?.getAttribute("aria-orientation") === "vertical";
    }
    set vertical(isVertical) {
        const tabList = this.#tabList;
        if (tabList && isVertical) tabList.setAttribute("aria-orientation", "vertical");
        else tabList.setAttribute("aria-orientation", "horizontal");
    }
    #setupComplete;
    #internals;
    connectedCallback() {
        this.#internals ||= this.attachInternals ? this.attachInternals() : null;
        const shadowRoot = this.shadowRoot || this.attachShadow({
            mode: "open",
            slotAssignment: "manual"
        });
        const tabListContainer = document.createElement("slot");
        tabListContainer.style.display = "flex";
        tabListContainer.setAttribute("part", "tablist-wrapper");
        tabListContainer.setAttribute("name", "tablist-wrapper");
        const tabListTabWrapper = document.createElement("div");
        tabListTabWrapper.setAttribute("part", "tablist-tab-wrapper");
        tabListTabWrapper.setAttribute("name", "tablist-tab-wrapper");
        const tabListSlot = document.createElement("slot");
        tabListSlot.setAttribute("part", "tablist");
        tabListSlot.setAttribute("name", "tablist");
        tabListTabWrapper.append(tabListSlot);
        const panelSlot = document.createElement("slot");
        panelSlot.setAttribute("part", "panel");
        panelSlot.setAttribute("name", "panel");
        const beforeTabSlot = document.createElement("slot");
        beforeTabSlot.setAttribute("part", "before-tabs");
        beforeTabSlot.setAttribute("name", "before-tabs");
        const afterTabSlot = document.createElement("slot");
        afterTabSlot.setAttribute("part", "after-tabs");
        afterTabSlot.setAttribute("name", "after-tabs");
        tabListContainer.append(beforeTabSlot, tabListTabWrapper, afterTabSlot);
        const afterSlot = document.createElement("slot");
        afterSlot.setAttribute("part", "after-panels");
        afterSlot.setAttribute("name", "after-panels");
        shadowRoot.replaceChildren(tabListContainer, panelSlot, afterSlot);
        if (this.#internals && "role" in this.#internals) this.#internals.role = "presentation";
        else this.setAttribute("role", "presentation");
        this.addEventListener("keydown", this);
        this.addEventListener("click", this);
        this.selectTab(-1);
        this.addEventListener("tab-container-change", this.#scrollToTab);
        this.addEventListener("click", this.#handleNavClick);
        this.#setupComplete = true;
    }
    attributeChangedCallback(name) {
        if (!this.isConnected || !this.shadowRoot) return;
        if (name === "vertical") this.vertical = this.hasAttribute("vertical");
    }
    handleEvent(event) {
        if (event.type === "click") return this.#handleTabClick(event);
        if (event.type === "keydown") return this.#handleKeydown(event);
    }
    #handleKeydown(event) {
        const tab = event.target?.closest?.('[role="tab"]');
        if (!tab) return;
        const tabs = this.#tabs;
        if (!tabs.includes(tab)) return;
        const currentIndex = this.selectedTabIndex;
        const vertical = tab.closest('[role="tablist"]')?.getAttribute("aria-orientation") === "vertical";
        const prevTab = event.code === "ArrowLeft" || vertical && event.code === "ArrowUp";
        const nextTab = event.code === "ArrowRight" || vertical && event.code === "ArrowDown";
        if (nextTab) {
            let index = currentIndex + 1;
            if (index >= tabs.length) index = 0;
            this.selectTab(index);
        } else if (prevTab) {
            let index = currentIndex - 1;
            if (index < 0) index = tabs.length - 1;
            this.selectTab(index);
        } else if (event.code === "Home") {
            this.selectTab(0);
            event.preventDefault();
        } else if (event.code === "End") {
            this.selectTab(tabs.length - 1);
            event.preventDefault();
        }
    }
    #handleTabClick(event) {
        const tab = event.target?.closest?.("[role=tab]");
        if (!tab) return;
        const tabs = this.#tabs;
        const index = tabs.indexOf(tab);
        if (index >= 0) this.selectTab(index);
    }
    #reflectAttributeToShadow(name, node) {
        if (this.hasAttribute(name)) {
            node.setAttribute(name, this.getAttribute(name));
            this.removeAttribute(name);
        }
    }
    #scrollToTab(event) {
        const { tab: tab } = event;
        if (!tab) return;
        tab.scrollIntoView({
            behavior: "auto",
            block: "nearest",
            inline: "center"
        });
    }
    get selectedTabIndex() {
        return this.#tabs.findIndex((el)=>el.matches("[aria-selected=true]"));
    }
    set selectedTabIndex(i) {
        this.selectTab(i);
    }
    get defaultTabIndex() {
        return Number(this.getAttribute("default-tab") || -1);
    }
    set defaultTabIndex(index) {
        this.setAttribute("default-tab", String(index));
    }
    #handleNavClick(event) {
        const target = event.target instanceof Element && event.target.closest("[data-tab-container-nav]");
        if (!target) return;
        const action = (target.dataset.tabContainerNav === "next" || target.dataset.tabContainerNav === "previous") && target.dataset.tabContainerNav;
        if (!action) throw new Error('Supported values of [data-tab-container-nav] are "previous" and "next"');
        const currentIndex = this.selectedTabIndex;
        if (action === "next") {
            let index = currentIndex + 1;
            if (index >= this.#tabs.length) index = 0;
            this.selectTab(index);
        } else {
            let index = currentIndex - 1;
            if (index < 0) index = this.#tabs.length - 1;
            this.selectTab(index);
        }
    }
    selectTab(index) {
        if (!this.#setupComplete) {
            const tabListSlot = this.#tabListSlot;
            const tabListWrapper = this.#tabListWrapper;
            const customTabList = this.querySelector("[role=tablist]");
            const customTabListWrapper = this.querySelector("[slot=tablist-wrapper]");
            if (customTabListWrapper && customTabListWrapper.closest(this.tagName) === this) $318d4e757804fac8$var$assignSlotWithFallback(tabListWrapper, customTabListWrapper);
            else if (customTabList && customTabList.closest(this.tagName) === this) $318d4e757804fac8$var$assignSlotWithFallback(tabListSlot, customTabList);
            else {
                this.#tabListTabWrapper.role = "tablist";
                $318d4e757804fac8$var$assignSlotWithFallback(tabListSlot, ...[
                    ...this.children
                ].filter((e)=>e.matches("[role=tab]")));
            }
            const tabList = this.#tabList;
            this.#reflectAttributeToShadow("aria-description", tabList);
            this.#reflectAttributeToShadow("aria-label", tabList);
            if (this.vertical) this.#tabList.setAttribute("aria-orientation", "vertical");
            const bringsOwnWrapper = this.querySelector("[slot=tablist-wrapper]")?.closest(this.tagName) === this;
            if (!bringsOwnWrapper) {
                const beforeSlotted = [];
                const afterTabSlotted = [];
                const afterSlotted = [];
                let autoSlotted = beforeSlotted;
                for (const child of this.children){
                    if (child.getAttribute("role") === "tab" || child.getAttribute("role") === "tablist") {
                        autoSlotted = afterTabSlotted;
                        continue;
                    }
                    if (child.getAttribute("role") === "tabpanel") {
                        autoSlotted = afterSlotted;
                        continue;
                    }
                    if (child.getAttribute("slot") === "before-tabs") beforeSlotted.push(child);
                    else if (child.getAttribute("slot") === "after-tabs") afterTabSlotted.push(child);
                    else autoSlotted.push(child);
                }
                $318d4e757804fac8$var$assignSlotWithFallback(this.#beforeTabsSlot, ...beforeSlotted);
                $318d4e757804fac8$var$assignSlotWithFallback(this.#afterTabsSlot, ...afterTabSlotted);
                $318d4e757804fac8$var$assignSlotWithFallback(this.#afterPanelsSlot, ...afterSlotted);
            }
            const defaultTab = this.defaultTabIndex;
            const defaultIndex = defaultTab >= 0 ? defaultTab : this.selectedTabIndex;
            index = index >= 0 ? index : Math.max(0, defaultIndex);
        }
        const tabs = this.#tabs;
        const panels = Array.from(this.querySelectorAll('[role="tabpanel"]')).filter((panel)=>panel.closest(this.tagName) === this);
        /**
		 * Out of bounds index
		 */ if (index > tabs.length - 1) throw new RangeError(`Index "${index}" out of bounds`);
        const selectedTab = tabs[index];
        const selectedPanel = panels[index];
        if (this.#setupComplete) {
            const cancelled = !this.dispatchEvent(new $318d4e757804fac8$export$6a3733570e3be366("tab-container-change", {
                tabIndex: index,
                bubbles: true,
                cancelable: true,
                tab: selectedTab,
                panel: selectedPanel
            }));
            if (cancelled) return;
        }
        for (const tab of tabs){
            tab.setAttribute("aria-selected", "false");
            tab.setAttribute("tabindex", "-1");
        }
        for (const panel of panels)if (!panel.hasAttribute("tabindex") && !panel.hasAttribute("data-tab-container-no-tabstop")) panel.setAttribute("tabindex", "0");
        selectedTab.setAttribute("aria-selected", "true");
        selectedTab.setAttribute("tabindex", "0");
        $318d4e757804fac8$var$assignSlotWithFallback(this.#panelSlot, selectedPanel);
        selectedPanel.hidden = false;
        if (this.#setupComplete) {
            selectedTab.focus();
            this.dispatchEvent(new $318d4e757804fac8$export$6a3733570e3be366("tab-container-changed", {
                tabIndex: index,
                bubbles: true,
                tab: selectedTab,
                panel: selectedPanel
            }));
        }
    }
    constructor(...args){
        super(...args);
        this.#onTabContainerChange = null;
        this.#onTabContainerChanged = null;
        this.#setupComplete = false;
    }
}



const $3c8be202ccaa416e$var$root = typeof globalThis !== "undefined" ? globalThis : window;
try {
    $3c8be202ccaa416e$var$root.TabContainerElement = (0, $318d4e757804fac8$export$d423894cc51549d0).define();
} catch (e) {
    if (!($3c8be202ccaa416e$var$root.DOMException && e instanceof DOMException && e.name === "NotSupportedError") && !(e instanceof ReferenceError)) throw e;
}
var $3c8be202ccaa416e$export$2e2bcd8739ae039 = (0, $318d4e757804fac8$export$d423894cc51549d0);


var $53a32769addd663f$export$2e2bcd8739ae039 = (0, $318d4e757804fac8$export$d423894cc51549d0);



const $6d3d71c6ab46848b$var$root = document.documentElement;
const $6d3d71c6ab46848b$var$setLayoutCssVariables = ()=>{
    const header = document.querySelector(".layout-body-header");
    const headerHeight = header?.clientHeight || 0;
    const headerCssProp = headerHeight ? `${headerHeight}px` : "0px";
    const headerY = header?.getBoundingClientRect().y || 0; // determine if header is visible, assign visible heights as well
    const visibleHeaderHeight = Math.max(0, headerY + headerHeight);
    const visibleHeaderCssProp = `${visibleHeaderHeight}px`;
    const footer = document.querySelector(".layout-body-footer");
    const footerHeight = footer?.clientHeight || 0;
    const footerCssProp = footerHeight ? `${footerHeight}px` : "0px";
    const footerY = footer?.getBoundingClientRect().y || 0; // determine if header and footer are visible, assign visible heights as well
    const visibleFooterHeight = footerY < window.innerHeight ? Math.min(window.innerHeight - footerY, footerHeight) : 0;
    const visibleFooterCssProp = `${visibleFooterHeight}px`;
    $6d3d71c6ab46848b$var$root.style.setProperty("--window-inner-height", `${window.innerHeight}px`, "important");
    $6d3d71c6ab46848b$var$root.style.setProperty("--atlas-header-height", headerCssProp, "important");
    $6d3d71c6ab46848b$var$root.style.setProperty("--atlas-footer-height", footerCssProp, "important");
    $6d3d71c6ab46848b$var$root.style.setProperty("--atlas-header-visible-height", visibleHeaderCssProp, "important");
    $6d3d71c6ab46848b$var$root.style.setProperty("--atlas-footer-visible-height", visibleFooterCssProp, "important");
};
let $6d3d71c6ab46848b$var$animationFrame = 0;
function $6d3d71c6ab46848b$var$scheduleUpdate(update) {
    cancelAnimationFrame($6d3d71c6ab46848b$var$animationFrame);
    $6d3d71c6ab46848b$var$animationFrame = requestAnimationFrame(update);
}
const $6d3d71c6ab46848b$export$901f073eb5b76009 = ()=>{
    window.dispatchEvent(new CustomEvent("atlas-layout-change-event"));
};
function $6d3d71c6ab46848b$export$5c53042c7d24b490() {
    window.addEventListener("atlas-layout-change-event", ()=>{
        $6d3d71c6ab46848b$var$scheduleUpdate($6d3d71c6ab46848b$var$setLayoutCssVariables);
    });
    window.addEventListener("resize", $6d3d71c6ab46848b$export$901f073eb5b76009, {
        passive: true
    });
    $6d3d71c6ab46848b$var$root.style.setProperty("--window-inner-height", `${window.innerHeight}px`);
    window.addEventListener("DOMContentLoaded", $6d3d71c6ab46848b$export$901f073eb5b76009);
    // determine if header/footer are visible below the top of the viewport - remove with atlas-js 1.13.1
    window.addEventListener("scroll", $6d3d71c6ab46848b$export$901f073eb5b76009, {
        passive: true
    });
}




function $eb50081cb8c1c364$export$b54c97eeb2b88f5d(selectors = `[data-focusable-if-scrollable]`) {
    const elements = Array.from(document.querySelectorAll(selectors));
    $eb50081cb8c1c364$var$setScrollableAttrs(elements);
    window.addEventListener("resize", ()=>{
        const elements = Array.from(document.querySelectorAll("[data-focusable-if-scrollable]"));
        $eb50081cb8c1c364$var$setScrollableAttrs(elements);
    });
}
function $eb50081cb8c1c364$var$setScrollableAttrs(elements) {
    for (const block of elements){
        const isHorizontallyScrollable = block.scrollWidth > block.clientWidth;
        const isVerticallyScrollable = block.scrollHeight > block.clientHeight;
        if (isHorizontallyScrollable) {
            block.setAttribute("role", "group");
            block.setAttribute("aria-label", "Horizontally scrollable element");
            block.tabIndex = 0;
        } else if (isVerticallyScrollable) {
            block.setAttribute("role", "group");
            block.setAttribute("aria-label", "Vertically scrollable element");
            block.tabIndex = 0;
        } else {
            block.removeAttribute("role");
            block.removeAttribute("aria-label");
            block.removeAttribute("tabindex");
        }
    }
}


function $6affabdeba5460cf$export$eab4cb1d5a93b779() {
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    window.addEventListener("click", (e)=>{
        const target = e.target instanceof Element && e.target.closest("[data-full-screen-main]");
        if (!target) return;
        return $6affabdeba5460cf$var$handleFullscreen();
    });
}
async function $6affabdeba5460cf$var$handleFullscreen() {
    const main = document.getElementById("main");
    const article = document.getElementById("article");
    if (!main || !article) return;
    const isFullScreened = main?.dataset.isFullScreened === "true";
    if (!isFullScreened) {
        article.style.overflow = "visible";
        main.style.display = "block";
        main.style.overflowX = "auto";
        await main.requestFullscreen({
            navigationUI: "show"
        });
        main.dataset.isFullScreened = "true";
    } else {
        main.dataset.isFullScreened = "false";
        article.style.cssText = "";
        if (document.fullscreenElement) await document.exitFullscreen();
    }
}


const $97683cc1acd86126$var$layoutsClasses = [
    "layout-single",
    "layout-twin",
    "layout-holy-grail",
    "layout-sidecar-left",
    "layout-sidecar-right",
    "layout-twin"
];
// A function that removes all classes that begin with layout- on the html element
function $97683cc1acd86126$var$setLayoutClass(layoutToSet) {
    for (const layoutClass of $97683cc1acd86126$var$layoutsClasses)document.documentElement.classList.remove(layoutClass);
    document.documentElement.classList.add(layoutToSet);
}
function $97683cc1acd86126$export$7418a22239be2e7() {
    window.addEventListener("click", (e)=>{
        const target = e.target instanceof Element && e.target.closest("[data-set-layout]");
        if (!target) return;
        const layoutToSet = target.dataset.setLayout || "not-found";
        if (!$97683cc1acd86126$var$layoutsClasses.includes(layoutToSet)) throw new Error("Attempting to set a layout class that does not match current list of available layouts");
        if (document.documentElement.classList.contains(layoutToSet)) return;
        $97683cc1acd86126$var$safeViewTransition(()=>{
            $97683cc1acd86126$var$setLayoutClass(layoutToSet);
            scrollTo({
                behavior: "instant",
                top: target.getBoundingClientRect().top - 200
            });
            const setThemeButtons = Array.from(document.querySelectorAll("[data-set-layout]"));
            for (const button of setThemeButtons)button.setAttribute("aria-pressed", "false");
            target.setAttribute("aria-pressed", "true");
        });
    });
    window.addEventListener("click", (e)=>{
        const target = e.target instanceof Element && e.target.closest("[data-toggle-debug]");
        if (!target) return;
        target.classList.toggle("button-filled");
        document.documentElement.classList.toggle("debug");
        target.setAttribute("aria-pressed", target.classList.contains("button-filled").toString());
    });
    window.addEventListener("click", (e)=>{
        const target = e.target instanceof Element && e.target.closest("[data-toggle-layout-height-constraint]");
        if (!target) return;
        target.classList.toggle("button-filled");
        document.documentElement.classList.toggle("layout-constrained");
        target.setAttribute("aria-pressed", target.classList.contains("button-filled").toString());
        window.dispatchEvent(new CustomEvent("atlas-layout-change-event"));
    });
    //
    window.addEventListener("click", (e)=>{
        const target = e.target instanceof Element && e.target.closest("[data-toggle-hero-visibility]");
        if (!target) return;
        target.classList.toggle("button-filled");
        const hero = document.querySelector(".layout-body-hero");
        if (!hero) return;
        hero.hidden = !hero.hidden;
        target.setAttribute("aria-pressed", target.classList.contains("button-filled").toString());
        window.dispatchEvent(new CustomEvent("atlas-layout-change-event"));
    });
    window.addEventListener("click", (e)=>{
        const target = e.target instanceof Element && e.target.closest("[data-toggle-footer-visibility]");
        if (!target) return;
        target.classList.toggle("button-filled");
        const footer = document.querySelector(".layout-body-footer");
        if (!footer) return;
        footer.hidden = !footer.hidden;
        target.setAttribute("aria-pressed", target.classList.contains("button-filled").toString());
        window.dispatchEvent(new CustomEvent("atlas-layout-change-event"));
    });
    window.addEventListener("click", (e)=>{
        const target = e.target instanceof Element && e.target.closest("[data-toggle-flyout-visibility]");
        if (!target) return;
        target.classList.toggle("button-filled");
        const flyout = document.querySelector(".layout-body-flyout");
        if (!flyout) return;
        $97683cc1acd86126$var$safeViewTransition(()=>{
            const html = document.documentElement;
            html.classList.toggle("layout-flyout-active");
            target.setAttribute("aria-pressed", target.classList.contains("button-filled").toString());
            window.dispatchEvent(new CustomEvent("atlas-layout-change-event"));
        });
    });
}
function $97683cc1acd86126$var$safeViewTransition(cb) {
    if (!document.startViewTransition) cb();
    else document.startViewTransition(()=>cb());
}


function $715792aaf7c0f6c4$export$bc2336b8340d680e() {
    addEventListener("fullscreenchange", ()=>{
        const isFullScreened = !document.fullscreenElement;
        const navContent = document.getElementById("menu-content");
        const nav = document.getElementById("menu");
        if (!nav) throw new Error("Need an element with an id of #nav before we can show a mobile menu");
        if (!navContent) throw new Error("Trying to modify classes on #menu-content, which does not exist.");
        const innerNavButton = nav.querySelector("[data-full-screen-nav]");
        if (!innerNavButton) throw new Error("Trying to modify classes on nav > [data-full-screen-nav], which does not exist.");
        const headerTrigger = document.querySelector("#header [data-full-screen-nav]");
        if (!headerTrigger) throw new Error("Trying to focus #header > [data-full-screen-nav], which does not exist.");
        if (isFullScreened) $715792aaf7c0f6c4$export$12c591e78e1e6616(navContent, nav, innerNavButton, headerTrigger);
    });
    document.addEventListener("fullscreenchange", ()=>{
        const nav = document.getElementById("menu");
        if (!nav) throw new Error("Need an element with an id of #nav before we can show a mobile menu");
        // logic is odd because of timing, this will run after a full screen exits
        const notFullScreen = document.fullscreenElement;
        if (notFullScreen) return;
        const trigger = document.querySelector("[data-full-screen-nav]");
        if (!trigger) return;
        const navContent = document.getElementById("menu-content");
        if (!navContent) throw new Error("Trying to modify classes on #menu-content, which does not exist.");
        const innerNavButton = nav.querySelector("[data-full-screen-nav]");
        if (!innerNavButton) throw new Error("Trying to modify classes on nav > [data-full-screen-nav], which does not exist.");
        $715792aaf7c0f6c4$export$12c591e78e1e6616(navContent, nav, innerNavButton, trigger);
    }, false);
    window.addEventListener("click", (e)=>{
        const trigger = e.target instanceof HTMLElement && e.target.closest("[data-full-screen-nav]");
        if (!trigger) return;
        const nav = document.getElementById("menu");
        if (!nav) throw new Error("Need an element with an id of #nav before we can show a mobile menu");
        const navContent = document.getElementById("menu-content");
        if (!navContent) throw new Error("Trying to modify classes on #menu-content, which does not exist.");
        const innerNavButton = nav.querySelector("[data-full-screen-nav]");
        if (!innerNavButton) throw new Error("Trying to modify classes on nav > [data-full-screen-nav], which does not exist.");
        // logic is odd because of timing, this will run before a full screen is requested
        const isFullScreened = document.fullscreenElement;
        if (isFullScreened) $715792aaf7c0f6c4$export$12c591e78e1e6616(navContent, nav, innerNavButton, trigger);
        else {
            navContent.classList.remove("display-none");
            navContent.classList.add("padding-inline-lg");
            nav.dataset.isFullScreened = "true";
            nav.style.overflowX = "auto";
            nav.requestFullscreen({
                navigationUI: "show"
            }).then(()=>{
                innerNavButton.classList.remove("display-none");
                innerNavButton.focus();
                innerNavButton.classList.add("burger-expanded");
            });
        }
    });
}
function $715792aaf7c0f6c4$export$12c591e78e1e6616(navContent, nav, innerNavButton, trigger) {
    innerNavButton.classList.add("display-none");
    innerNavButton.classList.remove("burger-expanded");
    navContent.classList.add("display-none");
    nav.dataset.isFullScreened = "false";
    navContent.classList.remove("padding-inline-lg");
    nav.style.cssText = "";
    document.exitFullscreen().then(()=>{
        trigger.focus();
    });
}


function $c69c51d058806b5b$export$c732d8e44fbc9cf6() {
    window.addEventListener("click", (e)=>{
        const target = e.target instanceof Element && e.target.closest("[data-direction-change]");
        if (!target) return;
        const direction = target.dataset.directionChange;
        if (direction !== "ltr" && direction !== "rtl") throw new Error("Misconfigured direction button");
        document.documentElement.dir = direction;
    });
}


(0, $f78667648d019a86$export$4c47704ed26c13e8)();
(0, $4e0192595c049343$export$bec8e2005d807978)();
(0, $c1991f537e9ddabd$export$7ae0af140e650b26)();
(0, $ac10d40a2fa020d1$export$cacf7dd05fca3e17)();
(0, $c1dcb31e94c13fa0$export$3bf7e98e931d1cdc)();
(0, $d902694ff4349214$export$f4ff70372302e0aa)();
(0, $0ff9b3ba2ca1da31$export$4b58943ac722c0ed)();
(0, $6affabdeba5460cf$export$eab4cb1d5a93b779)();
(0, $eb50081cb8c1c364$export$b54c97eeb2b88f5d)();
(0, $715792aaf7c0f6c4$export$bc2336b8340d680e)();
(0, $97683cc1acd86126$export$7418a22239be2e7)();
(0, $6d3d71c6ab46848b$export$5c53042c7d24b490)();
(0, $c69c51d058806b5b$export$c732d8e44fbc9cf6)();


//# sourceMappingURL=index.0dbed8b1.js.map
